export default {
title: 'AELU,',
ssv: 'အထူးကျွမ်းကျင်မှုဗီဇာ',
what_ssv: 'အထူးကျွမ်းကျင်မှုဗီဇာဆိုသည်မှာ',
representative_message: 'တာဝန်ရှိကိုယ်စားလှယ်၏အမှာစကား',
aeru_feature: 'AELU ၏ထူးခြားချက်များ',
aeru_how_to_use: 'aeru_how_to_use',
aeru_q_a: 'Q&A',
aeru_function: 'AELU ၏လုပ်ဆောင်ချက်များ',
aeru_fee: 'AELU ၏ဝန်ဆောင်ခနှုန်းထားများ',
login: 'မှတ်ပုံတင်ဝင်ရောက်ခြင်း',
db_top_comment1: 'လုပ်ငန်းစဉ်အစ "အထူးကျွမ်းကျင်လုပ်သားဗီဇာ သတ်မှတ်ချက်စာမေးပွဲ" စမက်ဖုန်းအွန်လိုင်းလေ့ကျင့်ပေးသည့်အင်တာနက်စာမျက်နှာဝပ်ဘ်ဆိုက်',
db_top_comment2: 'AELU သည် အထူးကျွမ်းကျင်လုပ်သားဗီဇာရရှိရန် စာမေးပွဲအတွက်လေ့ကျင့်ခြင်း၊ စာမေးပွဲဆိုင်ရာအချက်အလက်များနှင့်လျှောက်လွှာဆိုင်ရာအေဂျင်စီများဖြင့် /nထောက်ပံ့ပေးသောဝက်ဘ်ဝန်ဆောင်မှုတစ်ခုဖြစ်သည်။,',
db_top_pr: '"အထူးကျွမ်းကျင်ဗီဇာ" ကိုသုံးပြီး အခွင့်အလမ်းအသစ်ကို ဖမ်းဆုတ်ထားလိုက်ရ‌အောင်',
member_regist: 'အသင်းဝင်မှတ်ပုံတင်ခြင်း,',
registration_support_organization: 'မှတ်ပုံတင်အထောက်အကူပြုအဖွဲ့အစည်းဆိုတာဘာလဲ။,',
rso_dec1: 'အထူးကျွမ်းကျင်လုပ်သားစနစ်ဆိုသည်မှာ "အထူးကျွမ်းကျင်လုပ်သားဆိုင်ရာအဖွဲ့အစည်း"နှင့် "မှတ်ပုံတင်မှုဆိုင်ရာအထောက်အကူပြုအဖွဲ့အစည်း"ဟုဆိုသော အဖွဲ့အစည်း၂ခုရှိပါသည်။ အထူးကျွမ်းကျင်လုပ်သားဆိုင်ရာအဖွဲ့အစည်းဆိုသည်မှာ အထူးကျွမ်းကျင်လုပ်သားနိုင်ငံခြားသားကို အလုပ်ခန့်အပ်မည့်ကုမ္ပဏီ( လက်ခံသည့်အဖွဲ့အစည်း) ဖြစ်သည်။ အထူးကျွမ်းကျင်လုပ်သားဆိုင်ရာအဖွဲ့အစည်းဆိုသည်မှာ အထူးကျွမ်းကျင်လုပ်သားနိုင်ငံခြားသားများအား လုပ်ငန်းခွင်တွင် နေ့စဉ်နေထိုင်စားသောက်မှု၊ လူမှုဖူလုံရေးဆိုင်ရာများတွင် ထောက်ပံ့မှုပေးရပါမည်',
rso_dec2: 'အထူးကျွမ်းကျင်လုပ်သားနိုင်ငံခြားသားများကိုထောက်ပံ့မှုတွင် အထူးကျွမ်းကျင်မှုဆိုင်ရာ လုပ်ငန်းအကြောင်းအရာများလည်းရှိသည့်အတွက် အထူးကျွမ်းကျင်လုပ်သားနိုင်ငံခြားသားများကို ခန့်အပ်ထားသည့် ကုမ္မဏီ (အထူးကျွမ်းကျင်လုပ်သားဆိုင်ရာ အဖွဲ့အစည်း) မှ ကိုယ်တိုင်လက်တွေ့အကောင်အထည်ဖော်ရန်ခက်ခဲသောအဖြစ်အပျက်ကိစ္စများလည်း ရှိပါသည်။ မှတ်ပုံတင်မှုဆိုင်ရာအထောက်အကူပြုအဖွဲ့အစည်းဆိုသည်မှာ အထူးကျွမ်းကျင်လုပ်သားဆိုင်ရာအဖွဲ့အစည်းမှ တာဝန်ပေးအပ်ခြင်းခံရသော အထူးကျွမ်းကျင်လုပ်သားနိုင်ငံခြားသားများကို ထောက်ပံ့ပေးသောစီမံကိန်းများကို လုပ်ဆောင်ခြင်း၊ လက်တွေ့အကောင်အထည်ဖော်သော အဖွဲ့အစည်းဖြစ်ပါသည် ။,',
rso_dec3: 'မှတ်ပုံတင်မှုဆိုင်ရာအထောက်အကူပြုအဖွဲ့အစည်းဆိုသည်မှာ အထူးကျွမ်းကျင်လုပ်သားဆိုင်ရာအဖွဲ့အစည်းမှ တာဝန်ပေးအပ်ခြင်းခံရသော အထူးကျွမ်းကျင်လုပ်သားနိုင်ငံခြားသားများကို ထောက်ပံ့ပေးသောစီမံကိန်းများကို လုပ်ဆောင်ခြင်း၊ လက်တွေ့အကောင်အထည်ဖော်သော အဖွဲ့အစည်းဖြစ်ပါသည်။',
rso_dec4: 'မှတ်ပုံတင်မှုဆိုင်ရာအထောက်အကူပြုအဖွဲ့အစည်းဆိုသည်မှာ လက်ခံပေးထားသော အဖွဲ့အစည်းနှင့် ထောက်ပံ့ပေးမှုသဘောတူညီချက်စာချုပ်အရ နံပါတ် ၁ သတ်မှတ်ထားသောအထူးကျွမ်းကျင်လုပ်သားနိုင်ငံခြားသားများအားထောက်ပံ့သည့် စီမံကိန်းများကို အခြေခံကာ ထောက်ပံပေးမှုအရာများအားလုံးကို လက်တွေ့ဆောင်ရွက်သော အဖွဲ့အစည်းဖြစ်သည်။,',
rso_dec5: '○မှတ်ပုံတင်မှုဆိုင်ရာအထောက်အကူပြုအဖွဲ့အစည်းဖြစ်ရန် လူဝင်မှုကြီးကြပ်ရေးထိန်းချုပ်ရေးဌာန၏မှတ်ပုံတင်အသိအမှတ်ပြုမှုလိုအပ်သည်။,',
rso_dec6: '○မှတ်ပုံတင်ထားသောအသင်းအဖွဲ့များသည် မှတ်ပုံတင်အထောက်အကူပြုအဖွဲ့အစည်းတွင်မှတ်ပုံတင်ပြီးလူ၀င်မှုကြီးကြပ်ရေးဌာန၏ ၀ပ်ဘ်ဆိုဒ်တွင်ဖော်ပြပါမည်။,',
rso_dec7: '○မှတ်ပုံတင်ကာလသည် ၅ နှစ်ဖြစ်ပြီးသက်တမ်းတိုးရန်လိုအပ်သည်။,',
rso_dec8: '○မှတ်ပုံတင်မှုဆိုင်ရာအထောက်အကူပြုအဖွဲ့အစည်းများသည်လူဝင်မှုကြီးကြပ်ရေးဌာနသို့ ပုံမှန်သို့မဟုတ် အလျင်းသင့်သလို့ အကြောင်းကြားစာအမျိုးမျိုးတင်ပြရန်လိုအပ်သည်။,',
article1: 'အထူးကျွမ်းကျင်ဗီဇာ ဆိုသည်မှာ',
article1_dec1: '၂၀၁၈ခုနှစ် ဒီဇင်ဘာ ၈ ရက်တွင် ပြန်လည်ပြင်ဆင်ထားသောလူဝင်မှုကြီးကြပ်ရေးဆိုင်ရာအက်ဥပဒေကိုပြဌာန်းပြီးနောက် နေထိုင်ခွင့် (အထူးကျွမ်းကျင်)ကိုအသစ်ပြန်လည်သတ်မှတ်ခဲ့သည်။၂၀၁၉ခုနှစ် ဧပြီလတွင်စတင်ကျင့်သုံးခဲ့သည်။',
article1_dec2: 'အသစ်ပြန်လည်သတ်မှတ်ထားသော နေထိုင်ခွင့်အရည်အချင်းများ“ အထူးကျွမ်းကျင်များ” ကိုအဆင့်နှစ်ဆင့်ဖြင့်သတ်မှတ်လုပ်ဆောင်ပါမည်။ (နံပါတ် ၁ နှင့်နံပါတ် ၂),',
article1_dec3: 'သတ်မှတ်ထားသောလုပ်ငန်းအမျိူးအစားများမှာ ၁၄ ခုဖြစ်ပါသည်။,',
article1_dec4: 'နိုင်ငံခြားသားများအတွက်သတ်မှတ်ထားသောလိုအပ်ချက်မှာ“ဗဟုသုတအတော်အသင့်ရှိသောသူ သို့မဟုတ် အတွေ့အကြုံရှိသောကျွမ်းကျင်မှုလုပ်သား” ဖြစ်ရပါမည်။ တနည်းအားဖြင့် ကျွမ်ကျင်လက်တွေ့လုပ်သား ၃ နှစ်ကြာ လုပ်ကိုင်ထားသောသူများ သို့မဟုတ် ထိုအရည်အချင်းနှင့်ညီမျှသောဂျပန်စာနှင့်တကွကျွမ်းကျင်မှုစာမေးပွဲအောင်မြင်သူများအား ရည်ရွယ်ပါသည်။',
article1_dec5: '"အထူးကျွမ်းကျင်မှုနံပါတ် ၁"သည် သတ်မှတ်ထားသော ကျွမ်းကျင်မှုရှိသူတစ် ဦး အဖြစ် အကြာဆုံးကာလအဖြစ် ၅ နှစ်အထိနေထိုင်ခွင့်ပြုထားသည်။ မိသားစု၀င်များကိုနေထိုင်ခေါ်ယူခွင့်မပြုပါ။,',
article1_dec6: '"အထူးကျွမ်းကျင်မှုနံပါတ် ၂"သည် အတွေ့အကြုံပြည့်ဝသောအထူးကျွမ်းကျင်မှုရှိသူတစ် ဦး အနေဖြင့်အထူးကျွမ်းကျင်မှုအမှတ် ၁ ကာလအတွင်းတွင် အထူးပြုစာမေးပွဲဖြေဆိုအောင်မြင်ခြင်းဖြင့် သာမန်အလုပ်အကိုင်များနှင့် ညီမျှသောနေထိုင်မှုအရည်အချင်းကို ရရှိပါမည်၊(နေထိုင်ခွင့်ကာလ ပြောင်းလဲမှုများကြောင့် လက်တွေ့အနေအထာများအရ အမြဲတမ်းနေထိုင်ခွင့်များ၊ မိသားစုဝင်များနေထိုင်ခွင့်များလည်း ရရှိနိုင်ပါသည်',
article2: 'ကိုယ်စားလှယ်သတင်းစကား,',
article2_sub1: 'ဂျပန်ကို /nစွန့်ပစ်မထားပါနဲ့ဦး',
article2_dec1: 'ကျွမ်းကျင်သင်တန်းသားများအဖြစ်ဂျပန်နိုင်ငံသို့ရောက်ရှိလာခဲ့ပြီး အတတ်ပညာများကို လေ့လာသင်ယူကာ မိမိနိုင်ငံဖွံ့ဖြိုးတိုးတက်ရေးအတွက် အစွမ်းကုန်ကြိုးစားအားထုတ်လိုစိတ်ရှိကြသော များစွားသော ကျွမ်းကျင်လုပ်သားများ၊ မိမိနိုင်ငံသို့ပြန်လည်ရောက်ရှိသွားကြသော ကျွမ်းကျင်လုပ်သားများကို ရင်ထဲမှ လှိုက်လှိုက်လှဲလှဲဖြင့်ကျေးဇူးတင်ရှိပါသည်။ အောင်မြင်တိုးတက်ရန်တစ်ခုတည်းအတွက် မရွေးချယ်ဘဲ မိသားစုအတွက် မိမိနိုင်ငံတွင် ကြိုးစားအားထုတ်နေပြကြသော ပုံရိပ်များသည် ယနေ့ခေတ် ဂျပန်နိုင်ငံတွင် မရှိတော့သော ရှေးခေတ်ဂျပန်လူမျိုတို့၏ ပုံရိပ်ဟု ထင်မိပါသည်။ ကျွမ်းကျင်လုပ်သားလုပ်ငန်းတွင်ကာလကြာရှည်စွာ လုပ်ကိုင်နေသည့်အတွက် ကျွမ်းကျင်လုပ်သားဗီဇာဖြင့်သာ ပြည်ဝင်ခွင့်အခွင့်အလမ်းရှိပြီး ဂျပန်နိုင်ငံတွင် ကောင်းစွာ လေ့ကျင့်သင်ကြားပြီး မိမိနိုင်ငံတွင် လုပ်ငန်းလုပ်ဆောင်ကာ မိမိနိုင်ငံတွင် အောင်မြင်နေသော ပုံရိပ်များကိုလည်း များကိုလည် များစွာ တွေ့မြင်ရပါသည်။ သို့သော် သတ်မှတ်ထားသောကာလတွင် သင်ယူမှုများမပြီးဆုံးနိုင်ခြင်း တဖန် ဂျပန်နိုင်ငံတွင် ဆက်လက် လုပ်ကိုင်နိုင်သော ဗီဇာ "အထူးကျွမ်းကျင်လုပ်သားဗီဇာ"ကို ၂၀၁၉ခုနှစ် ဧပြီလတွင် လက်တွေ့အကောင်အထည်ဖော် သတ်မှတ်ခဲ့ပါသည်။ ဂျပန်နိုင်ငံတွင် ယနေ့ခေတ်တွင် နည်းပါးနေပြီဖြစ်သော မျက်လုံးများထဲတွင် ကြိုးစားလိုစိတ်များ ‌မြင်နေရသော နိုင်ငံခြားသားများဖြင့် ဂျပန်နိင်ငံ၏ တိုးတက်ရေးကို လုပ်ဆောင်နိုင်မည်ဆိုပါက အလွန်ကောင်းမွန်မည်ဟု တွေးမိပါသည်။ ဂျပန်ဟုဆိုသောနိုင်ငံကို ချစ်ခင်မြတ်နိုးကာ အမြဲတမ်းနေထိုင်ခွင့်ရရှိသော နိုင်ငံခြားသားများ တိုးများလာကာ အတူတကွ နေထိုင်နိုင်သော လူမှုပတ်ဝန်းကျင်ကို တည်ဆောက်ချင်ပါသည်။',
article2_dec2: 'ကုမ္ပဏီလီမိတက်များကို တွေ့မြင်လာနိုင်မှု',
article2_dec3: 'ကိုယ်စားလှယ်ဖြစ်သော ဥက္ကဌ',
article2_dec4: 'Kazuhiko Horiuchi,',
article3: 'AELU မှပံ့ပိုးပေးမည့်အချက်သုံးချက်,',
article3_sub1: 'အွန်လိုင်းစာမေးပွဲများအတွက်လေ့လာခြင်းများ',
article3_sub1_dec1: 'စမတ်ဖုန်းဖြင့်ကျွမ်းကျင်မှုစာမေးပွဲအတွက်ကြိုတင်ပြင်ဆင်မှု ပြုလုပ်နိုင်သော“ AELU” ၏မေးခွန်းဟောင်းများကိုအစပြုကာမေခွန်းများကို ကျွမ်းကျင်သူများမှ လုပ်ငန်းအမျိုးအစား ၁၄ ခု မှမေးခွန်း ၃၀ကို ပြင်ဆင်ထားပြီးနောက် စာမေးပွဲရက်မတိုင်မှီတွင် အကြိမ်ကြိမ်အခါခါပြင်ဆင်နိုင်သည်။ AI မှထွက်ပေါ်လာသောမေးခွန်းများတွင် သတ်မှတ်ထားသောရမှတ်ထက်ကျော်လွန်ပြီး ဖြေဆိုနိုင်ပါကစာမေးပွဲအောင်မည်မှာသေချာသည်။,',
article3_sub2: 'စာမေးပွဲအတွက်သတင်းအချက်များ',
article3_sub2_dec1: 'စာမေးပွဲအချက်အလက်များသည် ဂျပန်သို့လာရောက်သော နိုင်ငံခြားသားများအတွက် နားလည်ရန်အလွန်ခက်ခဲသောကြောင့် မှတ်ပုံတင်ပြီးနောက်တွင် ရွေးချယ်ထားသောလုပ်ငန်းများ၏ ထိုစာမေးပွဲအချက်အလက်များက ပြောင်းလဲပါကအလိုအလျောက် ထပ်မံထည့်သွင်းကာ အသုံးပြုသူကို အကြောင်းကြားပါမည်။',
article3_sub3: 'စာမေးပွဲလျှောက်လွှာကိုယ်စားလှယ်,',
article3_sub3_dec1: 'စာမေးပွဲအချက်အလက်နှင့်အတူ စာမေးပွဲအတွက် လာရောက်လျှောက်ထားစဉ်တွင် ဂျပန်သို့လာရောက်သောနိုင်ငံခြားသားများအတွက် အလွန်ခက်ခဲပြီး အွန်လိုင်းမှ လုပ်ဆောင်ရမည့် ၎င်းအချက်များကို မလုပ်ဆောင်ပါက လည်း စာမေးပွဲဖြေဆိုခွင့်မရရှိနိုင်ပါ။ မှတ်ပုံတင်သည့်အချိန်တွင်သတင်းအချက်အလက်ကို မှတ်တမ်းတင်ထားပြီး လျှောက်လွှာပုံစံကိုသိမ်းထားပြီးဖြစ်သည်။ စာမေးပွဲအတွက်ကြေညာချက်နှင့်တစ်ချိန်တည်းတွင်လျှောက်ထားနိုင်သည့် စနစ်ဖြစ်သည်။',
article4: 'စာမေးပွဲအောင်မြင်ပြီးနောက်လုပ်ငန်းကိုမိတ်ဆက်ပေးခြင်း',
article4_sub1: 'အောင်မြင်သောလျှောက်ထားသူများကိုဂုဏ်ပြုခြင်း။ n ငွေပြန်အမ်းခြင်း (ပြည်တွင်း (သို့) နိုင်ငံတကာများသို့),',
article4_sub1_dec1: 'အကယ်၍ သင်သည်ဂျပန်၌နေထိုင်ပြီး AELU ကိုအသုံးပြုပြီး စာမေးပွဲအောင်မြင်ပြီး မိမိ၏အသုံးပြုသည့်မျက်နှာပြင်သို့ အောင်မြင်သည့်နံပါတ်နှင့်အောင်လက်မှတ်ကိုတင်ပါကငွေပြန်အမ်းငွေရရှိမည်။ ပြန်လည်ရရှိမည့်ထုတ်ကုန် - အွန်လိုင်းလက်ဆောင်လက်မှတ် (အမေဇုန် လက်ဆောင်လက်မှတ်အီးမေးလ်ပုံစံဖြင့်) Googleplay, iTunes လက်ဆောင်ကဒ်များ ယန်း ၅၀၀၀နှင့်ညီမျှသော လိုင်း ၏တရားဝင်အကောင့်မှ ပြန်လည်ပေးအပ်ခြင်း',
article4_sub2: 'သူငယ်ချင်းအား မိတ်ဆက်ပေးသည့်လုပ်ဆောင်ချက်များ',
article4_sub2_dec1: 'ဂျပန်ပြည်တွင်းသို့မဟုတ် ပြည်ပမှဂျပန်သို့လာရောက်လိုသောနိုင်ငံခြားသားများကို FB အဖွဲ့သို့ဖိတ်ကြားပြီး အသုံးပြုသူအား မိမိကိုယ်ပိုင်စီမံခန့်ခွဲမှုနံပါတ်ကိုပြောပြပြီးထိုနံပါတ်နှင့်ဆက်စပ်သောသူအားငွေပြန်ပေးမည်။ အဖွဲ့ဝင်အဖြစ်ဝင်ရောက်ပီး တစ်လကြာပါက မိတ်ဆက်ပေးသူအား အွန်လိုင်းလက်ဆောင်လက်မှတ် ယန်း ၁၀၀၀ ကိုပြန်လည်ပေးအပ်ပါမည်။',
article4_sub3: 'ဗီဇာရရှိပြီးနောက်အလုပ်ရှာခြင်းသည် \ nAI အလိုအလျောက် သတ်မှတ်ထားပြီးသား ဖြစ်ပါသည်။(မသတ်မှတ်ရသေးသော),',
article4_sub3_dec1: 'AELU ကို အသုံးပြု၍ အသိအမှတ်ပြုလက်မှတ်ရရှိပြီးပါက အသုံးပြုသူမျက်နှာပြင်ပေါ်တွင် အောင်မြင်ထားသောအောင်လက်မှတ် နံပါတ်နှင့် အောင်လက်မှတ်ကို တင်လိုက်ပါက ဂျပန်တစ်နိုင်ငံလုံးရှိကုမ္ပဏီများမှအလိုအလျောက်ကမ်းလှမ်းမှုများကိုလက်ခံရရှိလိမ့်မည်။ လူတွေ့မေးမြန်းခြင်းများကိုလည်းအွန်လိုင်းမှပြုလုပ်ပြီး ကြိုတင်ကာအလုပ်ခန့်အပ်လွှာများကိုလည်း အွန်လိုင်းမှဆက်သွယ်လုပ်ဆောင်ကာ လုံခြုံစိတ်အေးစွာ ဂျပန်နိုင်ငံသို့ဝင်ရောက်၍ အလုပ်လုပ်နိုင်သည်။',
article4_sub4: 'နေထိုင်ခွင့်လက်မှတ်ပုံမှန်စစ်ဆေးမှုများဖြင့် \ n ငွေပြန်အမ်းခြင်း (မဆုံးဖြတ်ရသေး),',
article4_sub4_dec1: 'နေထိုင်ခွင့်လက်မှတ်ကဒ်ပြားစစ်ဆေးခြင်း အက်ပလီကေးရှင်းဖြင့် "တစ်ကြိမ်စစ်ဆေးသည့်ခလုတ်"ဖြင့် AELU မရှိဘဲ ကိုတစ်လလျှင်တစ်ကြိမ် နေထိုင်ခွင့်ကဒ်ပြားစစ်ဆေးခြင်းလုပ်ဆောင်ပါကတစ်နှစ်အတွင်းယန်း ၁၀,၀၀၀ ပြန်လည်ရရှိပါမည်။,',
article5: 'အခြေခံကျသော လုပ်ဆောင်ချက်များမိတ်ဆက်ခြင်း',
article5_sub1: 'ဖြေဆိုထားသော မေးခွန်းပုစ္တာများကို ပြန်လည်ကြည့်ရှု့နိုင်သည်',
article5_sub1_dec1: 'မိမိမှအွန်လိုင်းလေ့ကျင့်သင်ကြားပေးသောစာမေးပွဲအကြောင်းအရာများကိုစုဆောင်းပြီးကိုယ်ပိုင်ကိရိယာများကို သုံး၍ အသုံးပြုသူများ၏အလေ့အထများကိုနားလည်ပြီ ခက်ခဲသောမေးခွန်းများကို ဖြေဆိုနိုင်ပါမည်။ စာမေးပွဲအတွက်စိတ်ကြိုက်ကြိုတင်ပြင်ဆင်နိုင်ရန်အတွက် ရမှတ်များနှင့်စာမေးပွဲအချိန်အားလုံးကိုမှတ်တမ်းတင်ထားပြီး အမှန်တကယ်စာမေးပွဲ‌‌ ဖြေဆိုရမည့်နေ့အထိ အနီးကပ်‌လေ့ကျင့်ပေးနိုင်သည် တဖန် မိခင်ဘာသာစကားနှင့်ကတွဂျပန်ဘာသာဖြင့်ရေးသားထားသောကြောင့် မေးခွန်းများကိုပိုမိုနားလည်နိုင်ပါသည်။,',
article5_sub2: 'ပြည်ဝင်သည့်အချိန်တွင် မိမိ၏ကိုယ်ရေးအချက်အလက်များကို ထာဝရသိမ်းထားရန်',
article5_sub2_dec1: 'ကျွမ်းကျင်လုပ်သားဗီဇာစာမေးပွဲကိုဖြေဆိုအောင်မြင်ပြီးဗီဇာလျှောက်ထားသည့်အချိန်တွင် ကျွမ်းကျင်သင်တန်းသားတစ် ဦး အနေဖြင့် ပြည်ဝင်သည့်အချိန်တွင် ကိုယ်ရေးမှတ်တမ်းလိုအပ်ပါလိမ့်မည်။ မူလစီမံခန့်ခွဲမှုကြီးကြပ်အဖွဲ့အစည်း (ပူးပေါင်းပါဝင်ပေးသောအဖွဲ့အစည်း)၊ လုပ်သားစေလွတ်ပေးပို့ခြင်းအဖွဲ့အစည်းမှသိမ်းဆည်းထားသော်လည်း အထူးကျွမ်းကျင်ဗီဇာရရှိပြီးနောက်တွင်ကိုယ်တိုင်သိမ်းဆည်းနိုင်သည်။,',
article5_sub3: 'မိမိတိုင်းပြည်၊ နယ်ပယ်မှတ်ပုံတင်ခြင်းလုပ်ငန်း,',
article5_sub3_dec1: 'မိခင်ဘာသာစကားနှင့်ဂျပန်ဘာသာစကားကိုအတူတကွအသုံးပြုသောကြောင့်မေးခွန်းများကိုကောင်းစွာနားလည်ပြီး ဖြေဆိုမှုများကိုပြုလုပ်နိုင်သည်။ မူလစာမေးပွဲတွင် ဂျပန်ဘာသာတစ်မျိုးတည်းသာရှိသည့်အတွက် ဂျပန်ဘာသာစကားတစ်ခုတည်းဖြင့်သာ ဖြေဆိုရရှိနိုင်ပါသည်။',
article5_sub4: 'အသိအမှတ်ပြုလက်မှတ်စာမေးပွဲလိုအပ်ချက်နှင့်သတင်းအချက်အလက်များကိုပြန်လည်သတိပေးခြင်းများ',
article5_sub4_dec1: 'မိမိဆန္ဒရှိသောအလုပ်အကိုင်အတွက်စာမေးပွဲအချိန်ဇယားကိုစာမေးပွဲအုပ်စုတစ်ခုစီမှ HP သို့တင်ပို့သောအချိန်တွင် ၎င်းသည်အလိုအလျောက်သတိပေးပြီး အသုံးပြုသူကိုအကြောင်းကြားကာ၊အသုံးပြုသူမျက်နှာပြင်တွင် စာမေးပွဲရက်ကို သတ်မှတ်ကာ timer သည်အလိုအလျောက်ပေါ်လာပါလိမ့်မည်။',
article5_sub5: 'စိစစ်အသုံးပြုနည်းကို လုပ်ဆောင်ထားသော လေ့လာသင်ယူမှု',
article5_sub5_dec1: 'အသုံးပြုသူ၏အားနည်းချက်များကိုဖယ်ထုတ်ကာ စာမေးပွဲအတွက် ပြင်ဆင်မှုများလုပ်ဆောင်နိုင်သည်။,',
article5_sub6: 'စမတ်ဖုန်းကင်မရာများဖြင့်အွန်လိုင်းလေ့လာမှုများတိုင်ပင်ဆွေးနွေးမှုများနှင့်အင်တာဗျူးများ,',
article5_sub6_dec1: 'AELUကို အသုံးပြု၍ အသိအမှတ်ပြုလက်မှတ်စာမေးပွဲပြင်ဆင်မှုကိုပြုလုပ်နေစဉ်အတွင်း တွင် မေးခွန်းပုစ္ဆများ၏ အဓိပ္ပာယ်နှင့် အကြောင်းရင်းများရှင်းလင်းချက်များကို အွန်လိုင်းမှခေါ်ဆိုခြင်းနှင့် မက်ဆေ့ပို့စကားပြောခြင်းပုံစံဖြင့် လုပ်ဆောင်နိုင်ပါသည်။ ဂျပန်နှင့်အသားကျရင်းနှီးကျွမ်းဝင်သူများသို့မဟုတ် ဂျပန်နိုင်ငံအကြောင်းကို ကောင်းစွာနားလည်သ‌ဘောပေါက်ထားသူများအတွက် မလိုအပ်သောလည်း အခြေခံကျသောခေါ်ဆိုမှုတိုင်ပင်ဆွေးနွေးမှုဝန်ဆောင်မှုသည်စာမေးပွဲမတိုင်မီရှိလာနိုင်သောစိုးရိမ်မှုများကို ဖြေလျော့ရန်အတွက် အကောင်းဆုံးနည်းလမ်းဖြစ်သည်။,',
article6: 'အခကြေးငွေ',
article6_sub1: 'AELU အသုံးပြုခ,',
article6_sub1_dec1: 'အထူးကျွမ်းကျင်လုပ်သားဗီဇာလက်မှတ်စာမေးပွဲအတွက်စာလေ့လာခြင်းသည် အကန့်အသတ်မရှိလေ့လာမှုလုပ်ဆောင်နိုင်သည်။ မိခင်ဘာသာစကားဖြင့်အွန်လိုင်းတွင်တိုင်ပင်ဆွေးနွေးနိုင်သည်။ ပုံမှန်အချိန်များတွင်လည်း စကားပြန်အဖြစ်လည်းအသုံးပြုနိုင်သည်။ \ n စာမေးပွဲဖြေဆိုရမည့်နေ့တွင် စာမေးပွဲခန်းမအထိ လေ့ကျင့်မှုလုပ်ဆောင်နိုင်ပါသည်။ \ n ပြည်ဝင်သည့်အချိန်တွင် မိမိ၏ကိုယ်ရေးအချက်အလက်များကို အစဉ်အမြဲထိန်းသိမ်းထားနိုင်ပါတယ်။ \ n စာမေးပွဲဖြေဆိုအောင်မြင်ပြီးနောက် အထူးကျွမ်းကျင်လုပ်သားဗီဇာ Pass နံပါတ်ကိုသာမှတ်ပုံတင်လိုက်ပါက မိမိဆန္ဒရှိသောအလုပ်ကိုမိတ်ဆက်ပေးနိုင်ပါမည်။ (မဆုံးဖြတ်ရသေး),',
article6_sub2: 'စာမေးပွဲလျှောက်လွှာကိုယ်စားလှယ်,',
article6_sub2_dec1: 'အလုပ်လုပ်နေစဉ်ကာလအတွင်းလျှောက်လွှာ တင်၍ မရဘဲ သင်လျှောက်ထားခြင်းမရှိပါကအသိအမှတ်ပြုလက်မှတ်ရစာမေးပွဲကိုဖြေနိုင်မည်မဟုတ်သည့်အတွက် အထူးသတ်မှတ်စာမေးပွဲအကြောင်းအရာသတင်းအချက်အလက်များ ရရှိလာပါက ချက်ချင်း လျှောက်ထားခြင်းကို လုပ်ဆောင်ပေးပြီး စာမေးပွဲဖြေဆိုရမည့်ရက်ကို လက်လွတ်မသွားစေရန် သတိပေးခြင်းများလုပ်ဆောင်ပါမည်။',
article7: 'ငွေပြန်အမ်းနေသည့်လှုပ်ရှားမှုများ လက်တွေ့လုပ်ဆောင်ခြင်းများကို လုပ်ဆောင်ဆဲ',
article7_dec1: 'စာမေးပွဲဖြေဆိုအောင်မြင်သူများအထဲမှ ဗီဇာနံပါတ်ကို ဤ ၀ န်ဆောင်မှုတွင် မှတ်ပုံတင်သူများအား ငွေသား ၅၀၀၀ \ n ယန်းကို ပြန်လည်ပေးအပ်ပါမည်။ ငွေပြန်အမ်းနေသည့်လှုပ်ရှားမှုများတွင့် ပါဝင်နိုင်သည့်နည်းလမ်းများမှာ ဒီမှာနှိပ်ပါ,',
article8: 'ကဲ ယခုပဲ AELU မှာမှတ်ပုံတင်ကြပါစို့။,',
dashboard: 'အညွှန်းမာတိကာ',
member_info: 'မိမိ၏ကိုယ်ရေးအချက်အလက်များမှတ်ပုံတင်ခြင်း',
first_name: 'အမည်',
midle_name: 'အလယ်အမည်',
family_name: 'မိသားစုအမည်',
half_width_Roman: 'အင်္ဂလိပ်စာလုံး half width ဖြင့်',
password: 'စကားဝှက်',
password_confirm: 'စကားဝှက်နံပါတ်အတည်ပြုခြင်း),',
mail_adress: 'မေးလ်လိပ်စာ',
lineId: 'လိုင်း ID,',
country_id: 'နိုင်ငံကုဒ်နံပါတ်,',
phone: 'ဖုန်းနံပါတ်,',
issuing_country: 'မှတ်ပုံတင်ID ကတ်ထုတ်ပေးသည့်နိုင်ငံ / ဒေသကိုရွေးချယ်ပါ,',
IDtype: 'ID ကဒ်အမျိုးအစားရွေးချယ်ရန်',
residence_card: 'နေထိုင်ခွင့်လက်မှတ် (သို့) ID ကတ်,',
passport: 'နိုင်ငံကူးလက်မှတ်,',
regist: 'မှတ်ပုံတင်ခြင်း,',
is_required: 'မဖြစ်မနေလိုအပ်ပါသည်',
sign_up: 'အသစ်မှတ်ပုံတင်ခြင်း',
residence_front: 'မျက်နှာစာဘက်ခြင်းကို တင်ပြခြင်း',
residence_back: 'နောက်ဘက်ခြမ်းကိုတင်ပြခြင်း',
passport_upload: 'နိုင်ငံကူးလက်မှတ်တင်ပြခြင်း',
error_file: 'ကျေးဇူးပြု၍ ဓာတ်ပုံကိုတင်ပြပါ',
post_resume: 'ကိုယ်ရေးမှတ်တမ်းတင်သွင်းခြင်း',
resume_upload: 'ကိုယ်ရေးမှတ်တမ်းကိုတင်ပြခြင်း',
click_upload: 'နှိပ်ပြီး တင်ပါ',
image_drop: 'သို့မဟုတ်ရုပ်ပုံဖိုင်ကိုဆွဲယူပြီးချလိုက်ပါ,',
select_language: 'မိခင်ဘာသာစကားရွေးချယ်မှု,',
vietnamese: 'ဗီယက်နမ်ဘာသာ',
chinese: 'တရုတ်ဘာသာ',
english: 'အင်္ဂလိပ်ဘာသာ',
khmer: 'ခမာဘာသာ',
indonesian: 'အင်ဒိုနီးရှားဘာသာ',
tagalog: 'တဂါးလော့ဘာသာ',
burmese: 'မြန်မာဘာသာ',
hindu: 'ဟိန္ဒူဘာသာ',
lao: 'လာအိုဘာသာ',
mongolian: 'မွန်ဂိုဘာသာ',
bengali: 'ဘင်္ဂလီဘာသာ',
sinhala: 'ဆင်ဟာရာဘာသာ',
banglodesh: 'ဘင်္ဂလားဒေ့ရှ်ဘာသာ',
malay: 'မလေးဘာသာ',
nepali: 'နီပေါဘာသာ',
thai: 'ထိုင်းဘာသာ',
japanese: 'ဂျပန်ဘာသာ',
error_lang: 'ကျေးဇူးပြု၍ မိခင်ဘာသာစကားကိုရွေးချယ်ပါ။,',
select_ouccupation: 'အလုပ်အကိုင်အမျိုးအစားရွေးချယ်ခြင်း,',
select_max_three: 'သင်သုံးခုအထိရွေးချယ်နိုင်သည်။,',
industry_id_1: 'သူနာပြုအကူလုပ်ငန်း,',
industry_id_2: 'အဆောက်အဦး သန့်ရှင်းရေးလုပ်ငန်း',
industry_id_3: 'ကုန်ကြမ်းပစ္စည်းလုပ်ငန်း,',
industry_id_4: 'စက်မှုစက်ပစ္စည်းထုတ်လုပ်ခြင်းလုပ်ငန်း,',
industry_id_5: 'လျှပ်စစ်နှင့်အီလက်ထရောနစ်သတင်းအချက်အလက်နှင့်သက်ဆိုင်သောလုပ်ငန်းများ,',
industry_id_6: 'ဆောက်လုပ်ရေးလုပ်ငန်း,',
industry_id_7: 'သင်္ဘောတည်ဆောက်ရေး / အဏ္ဏဝါစက်မှုလုပ်ငန်း,',
industry_id_8: 'မော်တော်ယာဉ်ပြုပြင်ထိန်းသိမ်းမှုလုပ်ငန်း,',
industry_id_9: 'လေကြောင်းလုပ်ငန်း,',
industry_id_10: 'တည်းခိုခန်းလုပ်ငန်း',
industry_id_11: 'စိုက်ပျိုးရေး,',
industry_id_12: 'ငါးလုပ်ငန်း,',
industry_id_13: 'အစားအစာနှင့်အဖျော်ယမကာထုတ်လုပ်ငန်း',
industry_id_14: 'စားသောက်ဆိုင်လုပ်ငန်း',
industry: 'လုပ်ငန်းအမျိုးအစား',
error_occupation: 'ကျေးဇူးပြု၍ အလုပ်အမျိုးအစားတစ်ခုသို့မဟုတ်တစ်ခုထက် ပို၍ ရွေးချယ်ပါ။,',
do: 'လုပ်ရန်',
news_tpic: 'သတင်း',
days_until_exam: 'စာမေးပွဲဖြေသည်အထိကျန်ရှိသောရက်ပေါင်း,',
estimated_pass_rate: 'စာမေးပွဲအောင်မြင်နိုင်သည့်နှုန်းခန့်မှန်းခြေ,',
average_score_taken: 'ဖြေဆိုထားသော စာမေးပွဲ၏ပျမ်းမျှရမှတ်',
exam: 'စာမေးပွဲသည်',
let_aim: 'ကိုရည်မှန်းထားရ‌အောင်',
score: 'အမှတ်',
solve_problem: 'ဤပုစ္တာကိုဖြေရှင်းမည်။',
recommend_problem: 'AELU မှအကြံပြုထားသည့်အကြောင်းအရာများ',
solved_problem: 'ယခင်ကဖြေဆိုခဲ့သော ပုစ္တာများ',
looking_solved: 'ယခင်ကဖြေဆိုခဲ့သော ပုစ္တာများကို ကြည့်မည်',
consultaion_service: 'လေ့လာသင်ယူမှုနှင့်ဆိုင်ရာတိုင်ပင်ဆွေးနွေးသောဝန်ဆောင်မှု',
application_agency: 'စာမေးပွဲလျှောက်လွှာအေဂျင်စီဝန်ဆောင်မှု,',
billing: 'ငွေတောင်းခံခြင်း',
more_look: 'ပိုမိုကြည့်ရှုမည်',
more_look2: 'ပိုမိုကြည့်ရှုပါ,',
facebook: 'ဖေ့စ်ဘွတ်ခ်',
google: 'ဂူဂဲလ်,',
until_not_account: 'သင့်မှာအကောင့်မရှိသေးဘူးဆိုပါက',
or: 'ဒါမှမဟုတ်,',
other_way: 'အခြားနည်းလမ်းများဖြင့်',
not_have_account: 'အကောင့်မဖွင့်ရသေးသောသူများသည်',
have_account: 'အကောင့်ဖွင့်ထားပြီးသားရှိသောသူများသည်',
forgot_password: 'သင်၏စကားဝှက်ကိုမေ့သွားလျှင်,',
this: 'ဒီမှာ,',
at_login: 'နှင့်ဝင်မည်,',
pass_condition: 'အင်္ဂလိပ်စာလုံးအသေး အကြီး သင်္ကေတ စာလုံး ၈ လုံးနှင့်အထက်',
at_sign_up: 'ဖြင့် မှတ်ပုံတင်အသစ်,',
agreement1: 'အောက်ပါတို့ကိုသဘောတူပြီးဆက်လက်လုပ်ဆောင်ရန်ရွေးချယ်ခြင်းအားဖြင့် AELU၏',
terms: 'ဝန်ဆောင်မှုအားအသုံးပြုမှုဆိုင်ရာစည်းကမ်းချက်များ,',
agreement2: 'သဘောတူတယ်,',
agree: 'သဘောတူပြီးဆက်လုပ်ပါ,',
account_confirm: 'အတည်ပြုသည့်ကုတ်,',
confirm: 'အတည်ပြုချက်,',
not_confirm: 'အတည်ပြုကုဒ်အတည်မပြုရသေးပါ',
move_confiirm: 'အတည်ပြုကုဒ်ထည့်သွင်းမှုမျက်နှာပြင်သို့ရွှေ့ပါ,',
top: 'ထိပ်ဆုံး,',
news_list: 'သတင်းများ',
problim_list: 'ပုစ္ဆာများ',
learning_consul: 'လေ့လာမှုဆိုင်ရာတိုင်ပင်ဆွေးနွေးခြင်း',
agency: 'စာမေးပွဲသတင်းအချက်အလက်များ',
of_trend: 'စာမေးပွဲ၏လမ်းစဉ်များနှင့်ပတ်သတ်ပြီး',
start_test: 'စာမေးပွဲစတင်မည်',
study_mode: 'သင်ယူမှုပုံစံ,',
order_question: 'မေးခွန်း,',
of_question: 'မေးခွန်းတွင်',
question_current: 'မေးခွန်းအမှန်',
to_mypage: 'မိမိ၏စာမျက်နှာသို့,',
correct_answer: 'အဖြေမှန်!,',
correct_answer_normal: 'အဖြေမှန်',
no_correct_answer: 'အဖြေမှား',
next: 'နောက် မေးခွန်းသို့',
finish_all: 'အားလုံးသောမေးခွန်းများကိုဖြေကြားခဲ့သည်',
your_score: 'သင်၏ရမှတ်မှာ',
is: 'ဖြစ်သည်',
result_description: '"မေးခွန်းများကို ကြည့်မည်" ဖြစ်သည့်အတွက် တခြားမေးခွန်းများကိုလည်း ဖြေဆိုနိုင်ပါသည်၊ မေးခွန်းများစာမျက်နှာမှ ယခင်ဖြေခဲ့သော မေးခွန်းများကိုလည်း ပြန်လည်ကြည့်ရှု့နိုင်ပါသည်။',
back_quiz_list: 'မေးခွန်းများကိုကြည့်မည်',
retry: 'နောက်တစ်ကြိမ် ဒီမေးခွန်းကို ဖြေမည်,',
no_description: 'ရှင်းလင်းချက်မရှိပါ,',
show_ans: 'အဖြေကိုကြည့်မည်',
of_solved_problem: 'ယခင်ကဖြေဆိုခဲ့သော ပုစ္ဆာများ',
of_solved_problem_list: 'ယခင်ကဖြေဆိုခဲ့သော ပုစ္ဆာစာရင်းများ',
solved_description: 'သူနာပြုအကူလုပ်ငန်းအထူးကျွမ်းကျင်ဗီဇာစာမေးပွဲအတွက် လေ့လာသင်ယူမှုစာမေးပွဲကို ပြန်ကြည့်နိုင်သည်။,',
before_result: 'ယခင်ရလဒ်များ,',
looking_back: 'နောက်ပြန်ကြည့်မည်',
back_solved_problem_list: 'ယခင်ကဖြေဆိုခဲ့သော ပုစ္ဆာများစာရင်းကိုကြည့်မည်',
again_retry: 'နောက်တစ်ကြိမ် ဤပုစ္ဆာကို ပြန်ကြည့်မည်',
done_member_regist: 'အသင်း၀င်အဖြစ်မှတ်ပုံတင်ခြင်းအတွက်ကျေးဇူးတင်ပါသည်။,',
done_member_regist_description: '၀န်ဆောင်မှုအသီးသီးသည် ဝန်ဆောင်မှုအသုံးပြုခကိုပေးဆောင်ပြီးနောက်တွင် အသုံးပြုနိုင်ပါမည်။ \ n သင့်ရဲ့ငွေပေးချေမှုသတင်းအချက်အလက်မှတ်ပုံတင်ပေးပါ။',
choose_payment: 'ငွေပေးချေမှုနည်းလမ်းကိုရွေးချယ်ပါမည်',
service_content: 'ဝန်ဆောင်မှုအကြောင်းအရာများ',
test_info_service: 'စာမေးပွဲသတင်းအချက်အလက်ဝန်ဆောင်မှုလုပ်ငန်း',
usage_fee: 'အသုံးပြုခ',
test_fee: '500 ယန်း + အခွန်,',
application_fee: '20000 ယန်း + အခွန်,',
method_payment: 'ငွေပေးချေမှုနည်းလမ်း,',
LINE_pay: 'LINE ငွေပေးချေမှု,',
line_pay_description: 'ကျေးဇူးပြု၍ QR code ပုံရိပ်ကိုသိမ်းပြီး LINE Pay ၀ န်ဆောင်မှုတွင်ငွေပေးချေပါ။ LINE Pay တွင်ငွေပေးချေသည့်အနေအထားတွင် တစ်ဘက်မှ အသိအမှတ်ပြုရန်အတွက်စစ်ဆေးသည့်အချိန်အတွက် အချိန်အနည်းငယ်ကြာမြင့်ပါမည်',
save_qr: 'QR ကုဒ်ကိုသိမ်းပါ,',
next_stage: 'နောက်တစ်ခု,',
credit_card: 'အကြွေးဝယ်ကဒ်,',
copmplete_payment: 'ငွေပေးချေမှုပြီးပါပြီ,',
copmplete_payment_descript: 'ငွေပေးချေမှုပြီးသွားသည့်အတွက် အွန်လိုင်းစာမေးပွဲလေ့လာမှုလုပ်ဆောင်ချက်၊ စာမေးပွဲအချက်အလက်နှင့်စာမေးပွဲလျှောက်လွှာကိုယ်စားလှယ်အေဂျင်စီ များကိုအသုံးပြုနိုင်သည်။,',
start_sevice: 'ဝန်ဆောင်မှုကိုစတင်အသုံးပြုပါ,',
to_payment: 'ငွေပေးချေမှုမျက်နှာပြင်သို့',
of_news_list: 'သတင်းများ',
done_payment: 'ငွေပေးချေမှုပြီးပါပြီ',
tv_consult: 'တီဗီတယ်လီဖုန်းဖြင့်တိုင်ပင်ဆွေးနွေး,',
tell_consult: 'တယ်လီဖုန်းဖြင့်တိုင်ပင်ဆွေးနွေးမှု',
learning_consul_descript01: 'စာမေးပွဲလျှောက်လွှာ,',
learning_consul_descript02: 'ကိုယ်စားဆောင်ရွက်ပေးမည်,',
money_unit: 'ယန်း',
learning_consul_unit: 'တစ်ကြိမ်',
fault_payment1: 'ငွေပေးချေမှုမအောင်မြင်ပါ,',
fault_payment2: 'ကျေးဇူးပြု၍ ထပ်မံကြိုးစားပါ,',
no_examination: 'အဆင်မပြေသေးပါ',
no_exam: 'နောက်ထပ်စာမေးပွဲမရှိသေးပါ',
undecided: 'မဆုံးဖြတ်ရသေးပါ,',
retry_login: 'ကျေးဇူးပြုပြီးပြန်ဝင်ပါ,',
no_problem: 'ဖြေဆိုထားသော မေးခွန်းပုစ္ဆာမရှိပါ',
do_problem: 'မေးခွန်းပုစ္ဆာကိုဖြေဆိုမည်',
qa_title: 'မကြာခဏမေးတတ်သောမေးခွန်းများ,',
search_category: 'အမျိုးအစားအားဖြင့်ချုံငြုံထားခြင်း',
search_freeward: 'နှစ်သက်ရာစကားလုံးဖြင့်ရှာဖွေပါ,',
test_result: 'လေ့ကျင့်ဖြေဆိုသောစာမေးပွဲရလဒ်',
to_top: 'ထိပ်ဆုံးသို့,',
missPassword: 'လျှို့ဝှက်နံပါတ်သို့မဟုတ်အီးမေးလ်လိပ်စာမှားယွင်းနေသည်,',
sample_problem: 'အွန်လိုင်းစာမေးပွဲအတွက်လေ့လာခြင်းအတွေ့အကြုံကိုယူကြည့်ရအောင်',
exercises: 'လေ့ကျင့်ခန်းများ,',
let_exercises: 'ပုစ္ဆာတစ်ပုဒ်ကိုပဲ ဖြေရှင်းကြရအောင်။,',
to_qa: 'Q&Aကို ထပ်မံကြည့်ရှုမည်,',
read_more: 'ထပ်မံကြည့်ရှုမည်',
account_setting: 'အကောင့်ကို့ ပြင်ဆင်ခြင်း',
profile_setting: 'မိမိ၏ကိုယ်ရေးရာဇာဝင်ပရိုဖိုင်ကို ပြင်ဆင်ခြင်း',
notification_setting: 'အသိပေးချက်ပြင်ဆင်ခြင်း',
logout: 'ထွက်သွားခြင်း',
changeEmail: 'အီးမေးလိပ်စာပြောင်းခြင်း',
changePassword: 'စကားဝှက်ကိုပြောင်းခြင်း',
change: 'ပြောင်းလဲသည်',
save: 'သိမ်းဆည်းပါ',
change_success: 'ပြောင်းလဲနိုင်ခဲ့တယ်',
now_password: 'လက်ရှိစကားဝှက်',
new_password: 'စကားဝှကိအသစ်,',
check_new_password: 'စကားဝှက်အသစ် (အတည်ပြုချက်),',
do_logout: 'ထွက်သွားပြီ,',
done_learning_consul_payment: 'ငွေပေးချေမှုပြီးပါပြီ,',
past_exam: 'ယခင်ကမေးခွန်းဟောင်းများ',
update_info: 'နောက်ဆုံးပေါ်သတင်းအချက်အလက်များကိုအသစ်ပြောင်းခြင်း,',
official_sns: 'တရားဝင် SNS,',
privacy_policy: 'ကိုယ်ရေးအချက်အလက်မူဝါဒ,',
terms_service: 'ဝန်ဆောင်မှု၏စည်းကမ်းချက်များ,',
transaction_law: 'သတ်မှတ်ထားသောကုန်သွယ်လုပ်ငန်းခွန်ဥပဒေပေါ် အခြေခံထားသော ဇယား',
selectCountry: 'ကျေးဇူးပြု၍ နိုင်ငံတစ်ခုရွေးပါ,',
goInquiry: 'စုံစမ်းမှုကို ဆက်လက်ဆောင်ရွက်ပါ,',
lineInquiry: 'LINE မှတဆင့်ကျွန်ုပ်တို့ကိုဆက်သွယ်ပါ,',
regist_accept_certificate: 'အထူးကျွမ်းကျင်မှုဗီဇာရယူထားသော အောင်လက်မှတ်ကို မှတ်ပုံတင်ခြင်း',
accept_certificate_description: 'အောင်လက်မှတ်နှင့်နံပါတ်ကိုသင်မှတ်ပုံတင်နိုင်ပါတယ်,',
accept_certificate: 'အောင်လက်မှတ်',
accept_number: 'အောင်လက်မှတ် နံပါတ်,',
immigration_resume: 'ဂျပန်သို့ဝင်ရောက်သည့်အချိန်တွင်ကိုယ်ရေးရာဇဝင်ကိုမှတ်ပုံတင်ခြင်း,',
resendCode: 'ပြန်လည်အတည်ပြုကုဒ်နံပါတ်ကို နောက်တစ်ကြိမ်ပို့ခြင်း',
line_at_register: 'LINE @ မှတစ်ဆင့်ဝန်ဆောင်မှုကို စုံစမ်းမေးမြန်းခြင်း,',
study: 'လေ့လာခြင်း ပြန်ကြည့်ခြင်း',
study_text: 'လေ့လာသင်ယူရမည့်ဖတ်စာအုပ်ကို ဒေါင်းလုပ် လုပ်ပါ,',
do_resume_update: 'ကျေးဇူးပြု၍ သင်၏ကိုယ်ရေးရာဇဝင်အကျဉ်းကိုပို့ပါ,',
done_resume_update: 'သင်၏ကိုယ်ရေးရာဇဝင်ကိုမှတ်ပုံတင်ခြင်းအတွက်ကျေးဇူးတင်ပါသည်။,',
regist_resume_enter: 'ဂျပန်နိုင်ငံသို့ဝင်သည့်အချိန်တွင်မှတ်ပုံတင်ခြင်း',
about_company: 'လုပ်ငန်းလည်ပတ်နေသောကုမ္ပဏီအကြောင်း',
add_exam_info_detail: 'စာမေးပွဲအချက်အလက်များထပ်မံထည့်သွင်းထားသည် အသေးစိတ်သိရှိရန်နှင့် မှတ်ပုံတင်ရန်ဤနေရာကိုနှိပ်ပါ။,',
regist_result_get_money: 'သင်၏စာမေးပွဲရလဒ်များကိုမှတ်ပုံတင်ပြီးသင့်ငွေကိုရယူပါ။,',
detail: 'အသေးစိတ်,',
about_withdrawal_subsc: 'စာရင်းသွင်းခြင်းကိုပယ်ဖျက်ခြင်းနှင့်ဖျက်သိမ်းခြင်းအကြောင်း,',
apply_withdrawal: 'စာရင်းသွင်းခြင်းကိုပယ်ဖျက်ခြင်းလုပ်ဆောင်ချက်များအတွက်လျှောက်လွှာ,',
apply_subsc: 'သတ်မှတ်ပေးသွင်းငွေပေးချေခြင်းဖျက်သိမ်းခြင်းအတွက်လျှောက်လွှာ,',
about_withdrawal: 'စာရင်းသွင်းခြင်းကိုပယ်ဖျက်ခြင်းလျှောက်လွှာ,',
about_subsc: 'သတ်မှတ်ပေးသွင်းငွေပေးချေခြင်းဖျက်သိမ်းခြင်း',
exam_info: 'စာမေးပွဲသတင်းအချက်အလက်များ',
date: 'နေ့စွဲ',
day: 'နေ့ရက်',
place: 'နေရာ,',
result_publication: 'စာမေးပွဲရလဒ်ထုတ်ပြန်ခြင်း',
result_publication_place: 'စာမေးပွဲရလဒ်ထုတ်ပြန်သည်နေရာ,',
result_this_page: 'ဤစာမျက်နှာတွင်ကြေငြာလိမ့်မည်,',
exam_way: 'စာမေးပွဲပုံစံ,',
exam_way2: 'စာမေးပွဲမေးခွန်းပုံစံ,',
include_exam_fee: 'စာမေးပွဲကြေးအပါအဝင်,',
exam_application_desc: 'စာမေးပွဲအတွက်လျှောက်လွှာပုံစံတင်သွင်းခြင်းကိုယ်စားလှယ် \ n စာမေးပွဲကြီးကြပ်မှုအထွေထွေအတွင်းရေးမှူးဌာနနှင့်ဆက်သွယ်ခြင်း \ n စာမေးပွဲနေ့အတွက်အဆင်သင့်ပြင်ဆင်ခြင်းအတွက်ဆက်သွယ်အကြောင်းကြားခြင်း (LINE @) \ n စာမေးပွဲနှင့်ပတ်သက်သောမရှင်းလင်းသည့်မည်သည့်မေးခွန်းမဆိုဆွေးနွေးခြင်း,',
self_application: 'ကိုယ်တိုင်လျှောက်ထားပါ,',
application_method: 'လျှောက်ထားနည်း,',
under_this_url: 'ကျေးဇူးပြု၍ အောက်ပါ URL မှလျှောက်ထားပါ,',
do_appliction: 'စာမေးပွဲအတွက်လျှောက်ထားပါ,',
study_with_aeru: 'ထိပ်စာမျက်နှာမှ စာမေးပွဲလေ့လာမှုအတွက် လုပ်ဆောင်ချက်များကို သုံးပြီး စာမေးပွဲအောင်မြင်နှုန်းကို မြင့်တက်အောင်လုပ်ပါ။',
line_at_consul: 'LINE @ လေ့လာသင်ယူမှုဆိုင်ရာအကြံပေးဝန်ဆောင်မှု။',
instagram: 'အင်စတာဂရမ်',
do_signup: 'အတည်ပြုပြီးပါပြီ \ n ကျေးဇူးပြု၍ နောက်တစ်ခေါက် ပြန်ဝင်ပါ။',
gender: 'ကျား/မ',
man: 'အမျိုးသား',
woman: 'အမျိုးသမီး',
input_problem_title: 'မေးခွန်းပုစ္ဆာ၏ခေါင်းစဉ်သို့ဝင်ရောက်ပါမည်။',
still_no_problem: 'မေးခွန်းပုစ္ဆာမရှိပါ',
enter_in_problem_trend: 'ယနေ့အထိစာမေးပွဲနှင့်ပတ်သက်သော နည်းလမ်း ၊အဖြေ ဖြေဆိုနည်း (ရွေးချယ်ခြင်းအမျိုးအစား) အစရှိသောလွယ်ကူသောစာမေးပွဲဆိုင်ရာ ရှင်းလင်းချက်တို့ပါ ၀ င်သည်။',
correct: 'အဖြေမှန်,',
explanation: 'ရှင်းလင်းချက်',
problem: 'မေးခွန်းပုစ္ဆာ',
do_nursing_not_published: 'သူနာပြုအကူပြုစုစောင့်ရှောက်ရေးလုပ်ငန်းတွင် စာမေးပွဲသည်ကျင်းပသော်လည်း မေးခွန်းဟောင်းများကိုတရားဝင်ထုတ်ဝေခြင်းမရှိသေးပါ။,',
practical_exam_of_year: 'တစ်နှစ်တာလက်တွေ့လုပ်ဆောင်မှုစာမေးပွဲ',
judgment_test_of_year: '2019 ခုနှစ်အတွက် သတ်မှတ်စာမေးပွဲ,',
judgment_test_answer_of_year: '2019 ခုနှစ်အတွက် သတ်မှတ်စာမေးပွဲအဖြေ,',
not_yet_test_material: 'ကုန်ကြမ်းစက်မှုလုပ်ငန်းနယ်ပယ်တွင် စာမေးပွဲစစ်ဆေးခြင်းမရှိသေးပါ။',
not_yet_test_machinery: 'စက်မှုစက်ယန္တရားထုတ်လုပ်မှုလုပ်ငန်းနယ်ပယ်တွင် စာမေးပွဲစစ်ဆေးခြင်းမရှိသေးပါ။',
not_yet_test_electronic: 'လျှပ်စစ်နှင့်အီလက်ထရောနစ်သတင်းအချက်အလက်စက်မှုလုပ်ငန်းနယ်ပယ်တွင် စာမေးပွဲစစ်ဆေးခြင်းမရှိသေးပါ။',
not_yet_test_construction: 'ဆောက်လုပ်ရေးလုပ်ငန်းနယ်ပယ်တွင် စာမေးပွဲစစ်ဆေးခြင်းမရှိသေးပါ။',
not_yet_test_shipbuilding: 'သင်္ဘောတည်ဆောက်ရေးနှင့်အဏ္ဏဝါစက်မှုလုပ်ငန်းနယ်ပယ်တွင် စာမေးပွဲစစ်ဆေးခြင်းမရှိသေးပါ။',
do_automobile_not_published: 'မော်တော်ယာဉ်ပြုပြင်ထိန်းသိမ်းမှုလုပ်ငန်းနယ်ပယ်တွင် စာမေးပွဲကိုပြုလုပ်ကျင်းပနေသော်လည်း မေးခွန်းဟောင်းများကို တရားဝင်မထုတ်ရပြန်သေးပါ။,',
do_aviation_not_published: 'လေကြောင်းလုပ်ငန်းနယ်ပယ်တွင်စာမေးပွဲကိုပြုလုပ်ကျင်းပနေသော်လည်း မေးခွန်းဟောင်းများကို တရားဝင်မထုတ်ရပြန်သေးပါ။,',
do_agricultural_not_published: 'စိုက်ပျိုးရေးလုပ်ငန်းနယ်ပယ်တွင် စာမေးပွဲကိုပြုလုပ်ကျင်းပနေသော်လည်း မေးခွန်းဟောင်းများကို တရားဝင်မထုတ်ရပြန်သေးပါ။',
do_fishery_not_published: 'ငါးလုပ်ငန်းနယ်ပယ်တွင်စာမေးပွဲကိုပြုလုပ်ကျင်းပနေသော်လည်း မေးခွန်းဟောင်းများကို တရားဝင်မထုတ်ရပြန်သေးပါ။,',
do_food_not_published: 'အစားအစာနှင့်အဖျော်ယမကာထုတ်လုပ်မှုလုပ်ငန်းနယ်ပယ်တွင်စာမေးပွဲကိုပြုလုပ်ကျင်းပနေသော်လည်း မေးခွန်းဟောင်းများကို တရားဝင်မထုတ်ရပြန်သေးပါ။',
do_restaurant_not_published: 'စားသောက်ဆိုင်လုပ်ငန်းနယ်ပယ်တွင်စာမေးပွဲကိုပြုလုပ်ကျင်းပနေသော်လည်း မေးခွန်းဟောင်းများကို တရားဝင်မထုတ်ရပြန်သေးပါ။,',
schedule_undecided: '(* အချိန်ဇယားသည်မဆုံးဖြတ်ရသေးပါ)',
year: 'နှစ်',
month: 'လ',
texts_learning: 'စက်မှုလုပ်ငန်းတစ်ခုစီအတွက်လေ့လာရန်အတွက်ဖတ်စာအုပ်များ',
texts_learning_test: 'အထူးကျွမ်းကျင်မှုအကဲဖြတ်စာမေးပွဲလေ့လာရန်အတွက်ဖတ်စာအုပ် (ဂျပန်ဘာသာ)',
skill_test_sample: 'အထူးကျွမ်းကျင်မှုအကဲဖြတ်စာမေးပွဲနမူနာ',
japanese_test_sample: 'ဂျပန်အကဲဖြတ်စမ်းသပ်မှုစာမေးပွဲနမူနာ',
not_building_texts: 'ဆောက်လုပ်ရေးသန့်ရှင်းရေးလုပ်ငန်းအတွက်လေ့လာရန်သင်ရိုးညွှန်းတမ်းမရှိသေးပါ။',
not_material_texts: 'ကုန်ကြမ်းပစ္စည်းစက်မှုလုပ်ငန်းနယ်ပယ်အတွက် လေ့လာရန်သင်ရိုးညွှန်းတမ်းမရှိသေးပါ။',
not_machinery_texts: 'စက်မှုစက်ယန္တရားထုတ်လုပ်ခြင်းနှင့် ပတ်သတ်၍လေ့လာရန်သင်ရိုးညွှန်းတမ်းမရှိသေးပါ။',
not_electronic_texts: 'လျှပ်စစ်နှင့်အီလက်ထရောနစ်ဆိုင်ရာသတင်းအချက်အလက်နှင့်သက်ဆိုင်သောလုပ်ငန်းများအတွက်လေ့လာရန်သင်ရိုးညွှန်းတမ်းမရှိသေးပါ။',
not_shipbuilding_texts: 'သင်္ဘောတည်ဆောက်ရေး / အဏ္ဏဝါစက်မှုလုပ်ငန်းအတွက်လေ့လာရန်သင်ရိုးညွှန်းတမ်းမရှိသေးပါ။',
not_automobile_texts: 'မော်တော်ယာဉ်ပြုပြင်ထိန်းသိမ်းမှုလုပ်ငန်းအတွက်လေ့လာရန်သင်ရိုးညွှန်းတမ်းမရှိသေးပါ။',
not_accommodation_texts: 'တည်းခိုခန်းလုပ်ငန်းအတွက်လေ့လာရန်သင်ရိုးညွှန်းတမ်းမရှိသေးပါ။',
not_food_texts: 'အစားအစာနှင့်အဖျော်ယမကာထုတ်လုပ်မှုလုပ်ငန်းအတွက်လေ့လာရန်သင်ရိုးညွှန်းတမ်းမရှိသေးပါ။',
not_restaurant_texts: 'စားသောက်ဆိုင်လုပ်ငန်းအတွက် လေ့လာရန်သင်ရိုးညွှန်းတမ်းမရှိသေးပါ။',
each_depertment_texts: 'ဘာသာရပ်တစ်ခုချင်းစီ၏စာမေးပွဲအတွက်ဖတ်စာအုပ်',
skill_test_basic: 'ကျွမ်းကျင်မှုအကဲဖြတ်စာမေးပွဲအတွက်ဖတ်စာအုပ် (အခြေခံနည်းပညာ)',
skill_test_safety: 'ကျွမ်းကျင်မှုအကဲဖြတ်စာမေးပွဲအတွက်ဖတ်စာအုပ် (လုပ်ငန်းခွင်ဘေးကင်းလုံခြုံရေး / အရည်အသွေး)',
skill_test_aircraft: 'ကျွမ်းကျင်မှုအကဲဖြတ်စာမေးပွဲအတွက်ဖတ်စာအုပ် (လေယာဉ်ပျံနှင့်ဆိုင်သော အကြောင်းအရာ)',
texts_livestock: '[တိရစ္ဆာန်မွေးမြူရေးသင်တန်းများအတွက်ဖတ်စာအုပ်] ဂျပန်ဘာသာ',
texts_cultivated: '[စိုက်ပျိုးရေးနှင့် ပတ်သက်၍ လေ့လာရန်အတွက် ဖတ်စာအုပ်] ဂျပန်ဘာသာ',
skill_test_fishery: 'ငါးလုပ်ငန်းကျွမ်းကျင်မှုစစ်ဆေးခြင်းစာမေးပွဲ (ငါးလုပ်ငန်း)',
skill_test_general_fishery: 'ငါးလုပ်ငန်းကျွမ်းကျင်မှုစစ်ဆေးခြင်းစာမေးပွဲ (အထွေထွေငါးလုပ်ငန်း)',
skill_test_safety_fishery: 'ငါးလုပ်ငန်းကျွမ်းကျင်မှုစစ်ဆေးခြင်းစာမေးပွဲ (ငါးလုပ်ငန်းလုံခြုံမှု)',
skill_test_specialty_fishery: 'ငါးလုပ်ငန်းကျွမ်းကျင်မှုစစ်ဆေးခြင်းစာမေးပွဲ (ငါးလုပ်ငန်းဆိုင်ရာ ကျွမ်းကျင်မှု အထူး ငါးဖမ်းပိုက်နှင့်ဆက်စပ်သော)',
skill_test_related_fishery: 'ငါးလုပ်ငန်းကျွမ်းကျင်မှုစစ်ဆေးခြင်းစာမေးပွဲ (ငါးလုပ်ငန်းဆိုင်ရာ ကျွမ်းကျင်မှု အထူး ငါးဖမ်းလုပ်ငန်း)',
skill_test_aquaculture: 'ငါးလုပ်ငန်းကျွမ်းကျင်မှုစစ်ဆေးခြင်းစာမေးပွဲ(ငါးမွေးမြူရေး)',
skill_test_general_aquaculture: 'ငါးလုပ်ငန်းကျွမ်းကျင်မှုစစ်ဆေးခြင်းစာမေးပွဲ (သာမန်ငါးမွေးမြူရေးလုပ်ငန်း လုံခြုံစိတ်ချရမှု )',
skill_test_feeding_aquaculture: 'ငါးလုပ်ငန်းကျွမ်းကျင်မှုစစ်ဆေးခြင်းစာမေးပွဲ(အစာကျွေးခြင်းနှင့်ရေအောက်ယဉ်ကျေးမှုနှင့်ဆက်စပ်သော)',
skill_test_non_feeding_aquaculture: 'ငါးလုပ်ငန်းကျွမ်းကျင်မှုစစ်ဆေးခြင်းစာမေးပွဲ (အစာမကျွေးခြင်းနှင့်ရေအောက်ယဉ်ကျေးမှုနှင့်ဆက်စပ်မှုမရှိသော),',
registration_skill_visa: 'အထူးကျွမ်းကျင်မှုဗီဇာရရှိနိုင်ရေးအတွက် စာမေးပွဲအောင်မြင်မှုလက်မှတ်မှတ်ပုံတင်ခြင်း',
please_register_pdf_number: 'အထူးကျွမ်းကျင်မှုဗီဇာရရှိနိုင်ရေးအတွက် စာမေးပွဲအောင်မြင်မှုလက်မှတ်ဓာတ်ပုံ သိုမဟုတ် PDFနှင့် အောင်လက်မှတ်သက်သေခံကဒ်ပြား၏ အောင်လက်မှတ်နံပါတ်ကို မှတ်ပုံတင်ပါ။',
regist_and_get_cash_bag: 'လက်ရှိမှတ်ပုံတင်ထားပါက ငွေပြန်အမ်းခြင်းအတွက် ယန်း ၅၀၀၀ ရရှိပါမည်။',
thank_you_regist_visa_pass: 'အထူးကျွမ်းကျင်မှုဗီဇာရရှိနိုင်ရေးအတွက် စာမေးပွဲအောင်မြင်မှုလက်မှတ်မှတ်ပုံတင်ခြင်းအတွက် ကျေးဇူးတင်ရှိပါသည်။',
exam_info_detail: 'စာမေးပွဲဖြေဆိုရမည့်အကြေင်းအရာ',
em_exam_detail_language: 'ဒေသ ဘာသာစကားအစီအစဉ်',
em_exam_detail_method: 'ဘာသာရပ်စာမေးပွဲ လက်တွေ့စာ‌မေးပွဲ',
em_exam_detail_way: 'ကွန်ပျူတာ၊ စစ်ဆေးခြင်း ရေးဖြေစာမေးပွဲ CBTပုံစံများ တဖန် ထုတ်လုပ်မှုလုပ်ငန်းများဆိုင်ရာ စာမေးပွဲနည်းလမ်းများ',
em_exam_detail_section: 'စာမေးပွဲ ၁၉ခုခွဲခြားထားခြင်း(သတ္တုများပုံသွန်းခြင်း၊ အတုလုပ်ခြင်း၊ အသေပုံသွင်းခြင်း၊ စက်များပုံသွင်းခြင်း၊ သတ္တုနှိပ်ခြင်းနှင့်သံရည်ကြိုစက်၊ သံမဏိပြားများပြုလုပ်ခြင်း၊ သတ္တုပြားများပြုလုပ်ခြင်း၊ အလူမီနီယမ်ပြားများပုံဖော်လုပ်ဆောင်ခြင်း၊အပြီးသပ်ပုံဖော်ခြင်း၊ စက်ပစ္စည်းများစစ်ဆေးခြင်း၊ စက်ကိရိယာများ အန္တရယ်ကင်းရှင်းမှု၊ လျှပ်စစ်ပစ္စည်းများ တပ်ဆင်ခြင်း၊ အနုမြုရောင်ခြည်သုံးပစ္စည်းများ တပ်ဆင်ခြင်း၊လျှပ်စစ် ဆားကစ်ပြားများ ပုံဖော်လုပ်ဆောင်ခြင်း ၊ ပလက်စတစ်ဖွဲ့စည်းပုံ၊ ဆေးသုတ်ခြင်း၊ဂဟေဆော်ခြင်း၊စက်ရုံသုံးပစ္စည်းများကိုထုတ်ပိုးသောမိုများ ပြုလုပ်ခြင်းလုပ်ငန်း',
em_exam_detail_notify: 'စာမေးပွဲ‌ဖြေဆိုပြီးနောက်တွင် အီးမေလ်ဖြင့် ရလဒ်အကြောင်းကြားစာကို ပူးတွဲပို့ပါမည်',
em_exam_detail_border: 'ဘာသာရပ်ဆိုင်ရာ စာမေးပွဲ ၆၅%နှင့်အထက်\ n လက်တွေ့စာမေးပွဲတွင် ၆၀မှတ်နှင့်အထက်',
ss_exam_detail_language: 'ဂျပန်ဘာသာ',
ss_exam_detail_method: 'ကျွမ်းကျင်မှုစာမေးပွဲသည် လက်တွေ့စာမေးပွဲနှင့်တကွ ဘာသာရပ်စာ‌မေးပွဲကိုလိုက်ပြီး ကျင်းပပါမည်။ \ n လက်တွေ့စာမေးပွဲသည် လုပ်ငန်းအလိုက် ကျင်းပါပမည်။ \ n ဘာသာရပ်စာမေးပွဲသည် ရေးဖြေပုံစံဖြင့် လုပ်ငန်းအလိုက် ခွဲခြားကာ စာမေးပွဲကျင်းပါပမည်။',
ss_exam_detail_way: 'ရေးဖြေစာမေးပွဲပုံစံ ၊ တခြားပုံစံ',
ss_exam_detail_section: 'လက်တွေ့ကျွမ်းကျင်မှု၊ ကျွမ်းကျင်မှု - ဂဟေဆော်ခြင်း၊ ပန်းချီ၊ သံထည်လုပ်ငန်း၊လျှပ်စစ်ပစ္ဏည်းများတပ်ဆင်ခြင်း',
ss_exam_detail_notify: '-',
ss_exam_detail_border: 'ဘာသာရပ်ဆိုင်ရာစာမေးပွဲ - ၆၀% နှင့်အထက် \ n လက်တွေ့စာမေးပွဲ - လက်တွေ့ကျသောရလဒ်များကို အခြေခံ၍ စီရင်ခြင်း',
c_exam_detail_language: 'ဂျပန်ဘာသာ',
c_exam_detail_method: 'ကျွမ်းကျင်မှုစာမေးပွဲသည် လက်တွေ့ကျွမ်းကျင်မှုစစ်ဆေးခြင်းနှင့်ဘာသာရပ်စစ်ဆေးခြင်းတို့ဖြင့်ပြုလုပ်ပါမည်။',
c_exam_detail_way: 'ကွန်ပြူတာအခြေပြုစစ်ဆေးခြင်းဖြင့် CBT မှတဆင့်ဘာသာရပ်စာမေးပွဲနှင့်တကွလက်တွေ့စာမေးပွဲများကိုပြုလုပ်ပါမည်',
c_exam_detail_section: '-',
c_exam_detail_notify: 'အင်တာနက်စာမျက်နှာ တွင် တရားဝင်ဖော်ပြမည်',
c_exam_detail_border: 'ဘာသာရပ်ဆိုင်ရာစာမေးပွဲ - ၆၅% နှင့်အထက် \ n လက်တွေ့စာမေးပွဲ - လက်တွေ့စာမေးပွဲရလဒ်များကို အခြေခံ၍ ဆုံးဖြတ်ချက်ချခြင်း',
cm_exam_detail_language: 'ဂျပန်ဘာသာ',
cm_exam_detail_method: 'ကျွမ်းကျင်မှုစာမေးပွဲသည် လက်တွေ့ကျွမ်းကျင်မှုစစ်ဆေးခြင်းနှင့်ဘာသာရပ်စစ်ဆေးခြင်းတို့ဖြင့်ပြုလုပ်ပါမည်။',
cm_exam_detail_way: 'ကွန်ပြူတာအခြေပြုစစ်ဆေးခြင်းဖြင့် CBT မှတဆင့်ဘာသာရပ်စာမေးပွဲနှင့်တကွလက်တွေ့စာမေးပွဲများကိုပြုလုပ်ပါမည်',
cm_exam_detail_section: 'ဘာသာရပ်စာမေးပွဲ၏ ဘာသာရပ်များ၊ဖွဲ့စည်းတည်ဆောက်ပုံ လုပ်ဆောင်ချက်များနှင့်တကွ ကိုင်တွယ်ပုံနည်းလမ်းနှင့် ပတ်သတ်သည့် အခြေခံပညာအသိပညာဗဟုသုတ စစ်ဆေးခြင်း၊ပြုပြင် ပြင်ဆင်ခြင်းနှင့်တကွ ညှိနှိုင်းခြင်းနှင့် ပတ်သတ်သောအခြေခံဗဟုသုတ၊စနစ်တကျ လုပ်ဆောင်ထားသော စာမေးပွဲဖြေဆိုသည့်စက်၊ တိုင်းတာသည့် စက်နှင့်တကွ ပစ္စည်းကိရိယာများ၏ဖွဲ့စည်းတည်ဆောက်ပုံ၊လုပ်ဆောင်ချက်နှင့် တကွကိုင်တွယ်ပုံနည်းလမ်းနှင့်ပတ်သတ်သည့်အခြေခံပညာအသိပညာဗဟုသုတ၊ကုန်ကြမ်းပစ္စည်းများနှင့် လောင်စာဆီနှင့်အဆီများ၏အရည်အသွေးများနှင့်တကွအသုံးပြုမှုနှင့်ပတ်သတ်သော အခြေခံအသိပညာဗဟုသုတ လက်တွေ့စာမေးပွဲ ဘာသာရပ်များ ရိုးရှင်းသောအခြေခံအလုပ် တပ်ဆင်ခြင်း၊ခွဲခြင်းခြင်း၊ရိုးရှင်းသော စစ်ဆေးချက်များနှင့်တကွ ပစ္စည်းကိရိယာများ၏ဖွဲ့စည်းတည်ဆောက်ပုံ၊လုပ်ဆောင်ချက်နှင့်တကွ ကိုင်တွယ်ပုံနည်းလမ်းနှင့် ပတ်သတ်သည့် အခြေခံပညာအသိပညာဗဟုသုတ၊ကုန်ကြမ်းပစ္စည်းများနှင့် လောင်စာဆီနှင့် အဆီများ၏အရည်အသွေးများနှင့်တကွ အသုံးပြုမှုနှင့် ပတ်သတ်သော အခြေခံပညာဗဟုသုတ လက်တွေ့စာမေးပွဲဘာသာရ့ပ်များ၊ရိုးရှင်းသောအခြေခံအလုပ် တပ်ဆင်ခြင်း၊ခွဲခြမ်းခြင်း၊ရိုးရှင်းသောစစ်ဆေးချက်များနှင့်တကွ ညှိနှိုင်းမှုများ၊လွယ်ကူသော ပြုပြင်ထိန်းသိမ်းမှုကိုလုပ်နိုင်သော စာမေးပွဲဖြေဆိုသောစက်များ၊တိုင်းတာခြင်းကိရိယာနှင့် ကိရိယာများကိုင်တွယ်ခြင်း',
cm_exam_detail_notify: '-',
cm_exam_detail_border: 'ဘာသာရပ်စာမေးပွဲ - ၆၅% နှင့်အထက် \ n လက်တွေ့စာမေးပွဲ - စုစုပေါင်းရမှတ်သည် ၆၀% နှင့်အထက်ရှိသည်',
a_exam_detail_language: 'လက်တွေ့အကောင်အထည်ဖော်ထားသောဘာသာစကား',
a_exam_detail_way: 'ကွန်ပြုတာ အခြေပြုစစ်ဆေးခြင်းဖြင့် CBTအလိုက် ရေးဖြေစာမေးပွဲပုံစံ',
a_exam_detail_section: 'ဦးစီးဌာနသည့် ယေဘုယျအားဖြင့် စိုက်ပျိုးရေး၊ဘေးကင်းရေးနှင့် ကျန်းမာ‌ရေး၊စိုက်ပျိုးသောသီးနှံအမျိုးအစား/ဝိသေသလက္ခဏများ၊စိုက်ပျိုးရေးပတ်ဝန်းကျင်(စက်ရုံ/ပစ္စည်းကိရိယာ/ပစ္စည်းများ/စက်ယန္တရား)စိုက်ပျိုးနည်း/စီမံခန့်ခွဲမှု၊ပိုးမွှား၊ပေါင်းပင်များကို ထိန်းချုပ်ခြင်း၊ဓာတ်မြေသြဇာ၊ပိုးမွှား၊ပေါင်းပင်များကို ထိန်းချူပ်ခြင်း၊ဓာမြေသြဇာ၊ပိုးသတ်ဆေးများကို ကိုင်တွယ်ခြင်း၊မျိုးစေ့များကိုင်တွယ်ခြင်း၊သဘာဝပတ်ဝန်းကျင်စီမံခန့်ခွဲ့မှု၊ပစ္စည်းများ/ စက်ပစ္စည်းများ၊စက်များကိုင်တွယ်ခြင်း။',
a_exam_detail_notify: 'အင်တာနက်စာမျက်နှာ တွင် တရားဝင်ဖော်ပြမည်',
a_exam_detail_border: 'စုစုပေါင်းရမှတ်သည် တနိုင်ငံလုံးဆိုင်ရာ အမျိုးသားစိုက်ပျိုးရေးအသင်းမှချမှတ်ထားသော အခြေခံအချက်မှားကိုကျော်လွန်ခြင်း။',
avi_exam_detail_method: 'ကျွမ်းကျင်စာမေးပွဲသည် လက်တွေ့စာမေးပွဲနှင့် စာတွေ့စာမေးပွဲပြုလုပ်ပါသည်။',
avi_exam_detail_section: 'စာတွေ့စာမေးပွဲ လေကြောင်းနည်းမညာအဖွဲ့အစည်း၏ Home pageဝက်ဆိုဒ်တွင် တင်ထားသော စာများမှမေးပါမည်။ လက်တွေ့ကျွမ်းကျင်မှု့၊ လျှပ်စစ်တိုင်းတာခြင်း။',
avi_exam_detail_notify: '-',
avi_exam_detail_border: 'စာတွေ့စာမေးပွဲ 65％အထက် လက်တွေ့စာမေးပွဲ -စုစုပေါင်းအမှတ် 65％အထက်',
f_exam_detail_language: 'ဂျပန်ဘာသာာစကား',
f_exam_detail_method: 'ကျွမ်းကျင်မှုစာမေးပွဲကို လက်တွေ့စာမေးပွဲနှင့် စာတွေ့စာမေးပွဲတို့ ပြုလုပ်သည်။',
f_exam_detail_way: 'ကွန်ပျူတာအခြေခံသည့် စာမေးပွဲ (CBT)ဖြင့် စာတွေ့စာမေးပွဲ နှင့် လက်တွေ့စာမေးပွဲတို့ကို ပြုလုပ်သည်။',
f_exam_detail_section: 'စာမေးပွဲဘာသာရပ်နဲ့ပတ်သတ်ပြီး ငါးလုပ်ငန်း(ငါးဖမ်းလုပ်ငန်း)နောက်ထပ် ငါးလုပ်ငန်း(ငါးမွေးမြူရေး)အလုပ်အကိုင်တချို့တွင် သတ်မှတ်ထားသော အလုပ်နှင့်ပတ်သတ်ပြီး ကြီးကြပ်ရေးမှုူး၏ညွှန်ကြားမှု့ကိုနားလည်ပြီး တိကျမှန်ကန်စွာဆောင်ရွက်နိုင်ခြင်း၊နောက်ထပ် ကိုယ်တိုင်ဆုံးဖြတ်ချက်ဖြင့်ဆောင်ရွက် နိုင်ခြင်းတို့ကို အထူးအတည်ပြုရမည်။ ရိုးရှင်းစွာ ပရော်ဖက်ရှင်နယ်အသိပညာဗဟုသုတ ရှိမရှိကို အကဲဖြတ်မည်။အရာဝတ္ထပစ္စည်းမဟုတ်သည့်အတွက် ငါးလုပ်ငန်း(ငါးလုပ်ငန်း)နောက်ထပ်ငါးလုပ်ငန်း(ငါးမွေးမြူရေး)နှင့်ပတ်သတ်ပြီးစွမ်းဆောင်ရည်အတွက်လိုအပ်သော မှန်ကန်သောဆုံးဖြတ်ချက်နှင့် အလုပ်နှင့် ပတ်သတ်၍ဗဟုသုတရှိခြင်းသို့မဟုတ် မရှိခြင်းတို့ကိုအကဲဖြတ်ရန်ဖြစ်နိုင်သည်။',
f_exam_detail_notify: 'အင်တာနက်စာမျက်နှာ တွင် တရားဝင်ဖော်ပြမည်',
f_exam_detail_border: 'စာမေးပွဲနှင့် လက်တွေ့စာမေးပွဲ၏ စုစုပေါင်းရမှတ်သည် ကျွမ်းကျင်စစ်ဆေးမှုကိုစစ်ဆေးသော အေဂျင်စီကချမှတ်ထားသော တရားစီရင်မှုစံသတ်မှတ်ချက်ထက်ကျော်လွန်သော သူတို့ကိုလက်ခံသည်။',
no_exam_info: 'စာမေးပွဲအကြောင်းအရာများကို ထုတ်ဖော်ပြောကြားခြင်းမရှိသေးပါ။',
language: 'လက်တွေ့ ဘာသာစကား',
method: 'လက်တွေ့အကောင်အထည်ဖော်မှုနည်းလမ်း',
way: 'လက်တွေ့အကောင်အထည်ဖော်မှုနည်းလမ်း',
section: 'စာမေးပွဲအမျိုးအစား',
notify: 'စာမေးပွဲရလဒ်အသိပေးချက်',
border: 'စာမေးပွဲရလဒ်စံ',
go_line_at: 'လိုင်းသို့ @',
thank_you_and_deactivate: 'အသုံးပြုတဲ့အတွက် ကျေးဇူးတင်ပါတယ် \ n ဝန်ဆောင်မှုမှဖယ်ရန်လုပ်ထုံးလုပ်နည်းအတွက် ကျေးဇူးပြု၍ အောက်ပါလိုင်း @ window မှဖယ်ယူရန်အစီအစဉ်ကိုထည့်ပါ။ \ n ပုံမှန်ငွေပေးချေမှုကိုဖျက်သိမ်းခြင်းအတွက်၊ အောက်ပါလိုင်း @ window မှပုံမှန်ငွေပေးချေမှုကိုပယ်ဖျက်ပါ။ \ n မကြာမီအတည်ပြုချက်ကိုရပါက ဆက်လက်လုပ်ဆောင်ပါလိမ့်မယ်',
thank_you_and_subscribe: 'အသုံးပြုတဲ့အတွက် ကျေးဇူးတင်ပါတယ် \ n ပုံမှန်ငွေပေးချေမှုကိုဖျက်သိမ်းခြင်းအတွက်၊ အောက်ပါလိုင်း @ window မှပုံမှန်ငွေပေးချေမှုကိုပယ်ဖျက်ပါ။ \ n အတည်ပြုချက်ကိုလက်ခံရရှိပါက ချက်ချင်းစာချုပ်ဖျက်သိမ်းပါလိမ့်မယ်။',
ten_thousand_yen: 'ယန်းတစ်သောင်း',
yen_per_month: 'ယန်း/လ',
how_to_use_this_service: 'အသုံးပြုမှုပုံစံ',
selecting_a_browser: 'Browser ရွေးချယ်ခြင်း',
selecting_a_browser_dec: 'browser (Google chrome, Safari,edge စသဖြင့်) https // aelu.co.jp ကို ဆက်သွယ်ပါ/ အပလီမရှိပါ',
provisional_registration: 'ယာယီမှတ်ပုံတင်',
provisional_registration_dec: 'Facebook、GoogleIDဝင်ခြင်း သို့မဟုတ် mail adress နဲ့ မှတ်ပုံတင်ခြင်း ကိုယ်ပြောခြင်သော ဘာသာစကား ၊ကိုယ်လုပ်ခြင်သော အလုပ်အမျိုးအစား ကို ရွေးချယ်ပြီးနောက် onlineသတ်မှတ်စာမေးပွဲကို အစမ်းလေ့ကျင့်ရန် အကြောင်းအရာကိုလေ့လာနိုင်ပါသည်။',
full_registration: 'အမှန်တကယ်မှတ်ပုံတင်ခြင်း',
full_registration_dec: 'onlineသတ်မှတ်စာမေးပွဲ၏အစမ်းစာမေးပွဲအကြောင်းအရာစာမျက်နှာရှိသည် (အမှန်တကယ်မှတ်ပုံတင်ခြင်း)ကို နှိပ့်ပြီး အရေးကြီးသည့် အချက်အလက်ကို ထည့်ပြီး ၊အလုပ်အမျိုးအစား 14ခု ၏အစမ်းစာမေးပွဲ မေးခွန်းအားလုံးအစမှာserviceရှိပါသည်။',
name_validate_message: 'ကျေးဇူးပြု၍ သင်၏နိုင်ငံကူးလက်မှတ်တွင်ရေးဖြည့်ထားသောစာလုံးပေါင်းနှင့် တူညီသောစာလုံးရိုက်ဖြည့်ပါ။',
live_at_area: 'လက်ရှိနေထိုင်သည့် နေရာဒေသ',
agency_application: 'စာမေးပွဲဖောင်ကို ကိုယ်စားလျှောက်ခြင်း',
mypage: 'မိမိစာမျက်နှာသို့',
myanmar: 'မြန်မာဘာသာစကား',
exam_list: 'စာမေးပွဲအချိန်ဇယားစာရင်း',
no: 'အခန်း',
times: 'အကြိမ်',
application_start: 'လျှောက်လွှာစတင်ခြင်း',
application_end: 'လျှောက်လွှာပိတ်ခြင်း',
enforcement: 'လက်တွေ့အကောင်အထည်ဖော်ခြင်း',
applicated: 'လျှောက်လွှာတင်ပြီးစီးခြင်း',
reception_time: 'လက်ခံသည့်အချိန်',
announthment_d: 'စာမေးပွဲအောင်စားရင်းထွက်သည့်ရက်',
reception_period: 'လျှောက်လွှာတင်ရမည့်သတ်မှတ်ရက်',
detail_link: 'အသေးစိတ်ကြည့်ရန်',
exam_country: 'ကျင်းပသည့်နိုင်ငံ',
line: 'လိုင်း',
vietnum: 'ဗီယနမ်',
laos: 'လာအို',
malaysia: 'မလေးရှား',
bangladesh: 'ဘဂ်လားဒေ့ရှ်',
indo: 'အိန္ဒိယ',
nepal: 'နီပေါ',
mongol: 'မွန်ဂို',
indonesia: 'အင်ဒိုနီးရှား',
th: 'ထိုင်း',
philipine: 'ဖီလစ်ပီး',
my: 'မြန်မာ',
uzbekistan: 'ဥဇဘက်ကစ္စတန်',
pakistan: 'ပါကစ္စတန်',
japan: 'ဂျပန်',
news_title: 'အထူးအလုပ်သင်ဗီဇာနှင့်ပတ်သတ်သည့်သတင်း',
missNowPassword: 'လက်ရှိလျှို့ဝှက်နံပါတ်က မှားယွင်းနေသည်',
article6_sub2_dec2: 'သင်ဒီမှာလျှောက်ထားပါကစာမေးပွဲလျှောက်လွှာ၊ စာမေးပွဲဈေးနှင့်နေရာကိုစစ်ဆေးသည့်နေ့အထိကြေငြာမည်။',
create_naw_password: 'လျှို့ဝှက်နံပါတ်ပြောင်းခြင်း',
send_confirmcode: 'အတည်ပြု ကုတ်နံပါတ်ပို့လိုက်သည်',
edit: 'ပြောင်းလဲသည်',
success_new_password_setting: 'လျှို့ဝှက်နံပါတ်အသစ်ကို တပ်ဆင်လိုက်ပါပြီ',
error_email: 'မှတ်ပုံတင်မထားသော မေးလိပ်စာဖြစ်ပါတယ်',

click_here_businesses: "&quotစီးပွားရေးလုပ်ငန်းအတွက်ဒီနေရာကိုနှိပ်ပါ&quot",
regist_organization_staff_info: "စီးပွားရေး / အသုံးပြုသူအချက်အလက်မှတ်ပုံတင်ခြင်း၊",
organization_info: "စီးပွားရေးသတင်းအချက်အလက်၊",
staff_info: "အသုံးပြုသူအချက်အလက်၊",
org_name: "စီးပွားရေးနာမည်၊",
url: "URL၊",
org_scale: "စကေး",
org_zip: "စာတိုက်သင်္ကေတ",
org_adress1: "စီရင်စုများ၊",
org_adress2: "မြို့တော်",
org_adress3: "လိပ်စာ၊ တိုက်ခန်းအမည်",
org_industry: "စက်မှုလုပ်ငန်း",
org_category: "အမျိုးအစား",
org_description: "ဖော်ပြချက်၊",
org_established_at: "တည်ထောင်သည့်နှစ်၊",
org_phone: "စီးပွားရေးဖုန်းနံပါတ်၊",
failed_established_at: "မမှန်ကန်သောရက်စွဲ။ ",
staff_name: "အသုံးပြုသူအမည်၊",
form_miss: "ဖြည့်စွက်ပုံစံတွင်အမှားတစ်ခုရှိသည်။ ",

back_joboffer_detail: "အလုပ်အကိုင်အသေးစိတ်ကိုပြန်သွားပါ ",
create_joboffer: "အလုပ်တစ်ခု ဖန်တီးပါ၊",
edit_joboffer: "Edit Jobs၊",
stop_posting: "တင်ပို့ခြင်းကိုရပ်တန့်ပါ၊",
delete: "&quotဖျက်&quot",
job_title: "အလုပ်အကိုင်အမည်",
job_catch_phrase: "Job Catch Copy၊",
job_category: "အလုပ်အကိုင်အမျိုးအစား",
employed_company_name: "အလုပ်ခန့်ထားသောကုမ္ပဏီနာမည်၊",
work_location: "အလုပ်တည်နေရာ၊",
employment_status: "အလုပ်အကိုင်အခြေအနေ၊",
full_time_employee: "ပုံမှန်ဝန်ထမ်း၊",
part_time_job: "အချိန်ပိုင်းအလုပ်",
temporary_staff: "စေလွှတ်သည့်အလုပ်သမား",
contract_employee: "ကန်ထရိုက်တာ ၀ န်ထမ်း၊",
intern: "Intern၊",
subcontracting: "ကန်ထရိုက်၊",
contract: "ကန်ထရိုက်၊",
new_graduate: "ဘွဲ့ရတစ်ယောက်၊",
salary: "လစာ",
annual_income: "နှစ်စဉ်ဝင်ငွေ",
monthly_salary: "လစဉ်လစာ၊",
weekly_salary: "အပတ်စဉ်လစာ၊",
dayly_salary: "နေ့စဉ်လစာ၊",
job_offer_attension1: "အလုပ်ပါ ၀ င်မှုအတွက်ဥပဒေအရသတ်မှတ်ထားသောလုပ်ငန်းခွင်အခြေအနေများသတ်မှတ်ရန်လိုအပ်သည်",
job_offer_attension2: "ဥပဒေအရရှင်းရှင်းလင်းလင်းဖော်ပြရန်လိုအပ်သည့်လုပ်ငန်းခွင်အခြေအနေများစသည်တို့ကိုစစ်ဆေးပြီးအလုပ်အကြောင်းအရာကိုဖော်ပြပါ။ (ကိုးကားစရာ - ကျန်းမာရေး၊ အလုပ်သမားနှင့်လူမှုဖူလုံရေး ၀ န်ကြီးဌာန၊ Prefectural အလုပ်သမားဗျူရို &quotလုပ်သားအင်အားစုဆောင်းသောကုမ္ပဏီအားလုံးအတွက်&quot) ",
job_offer_attension3: "“ အကယ်၍ သင်ဟာပစ်မှတ်ထားတဲ့သူရဲ့အသက်၊ ကျား / မဒါမှမဟုတ်လူမှုရေးအဆင့်အတန်းကိုကန့်သတ်ထားတဲ့ဘာသာစကားကိုသုံးရင်အလုပ်တစ်ခုကိုလုပ်နိုင်မှာမဟုတ်ဘူး။ ",
job_offer_attension4: "မကြာခဏထုတ်ဝေမှုမရှိသောဥပမာများ -“ သူတို့အသက် ၂၀ ကျော်လာတာကိုကြိုဆိုပါတယ်”“ လူငယ်များကိုကြိုဆိုပါတယ်”“ အမျိုးသမီးများကကြိုဆို / ကန့်သတ်ချက်များ”“ ကျောင်းသားများသာ”",
work_content_appeal: "အလုပ်အကိုင်နှင့်အယူခံဝင်မှုအချက်များ၊",
work_content_appeal_desc: " အလုပ်ရှာသူတွေအနေနဲ့အယူခံဝင်မယ့်အချက်တွေကို ဦး ဆုံးပြောရင်ပိုပြီးလွယ်ကူလိမ့်မယ်။ ",
human_resources_seek: "ရှာဖွေရန်လူ့စွမ်းအားအရင်းအမြစ်၊",
human_resources_seek_desc: " သင်ရှာနေတဲ့ကျွမ်းကျင်မှုတွေသာမကအလုပ်ရှာဖွေနေတဲ့အလုပ်ခွင်ကိုစိတ်ကူးနိုင်တဲ့သတင်းအချက်အလက်တွေလည်းပါပါတယ်။ ",
working_hours: "အလုပ်ချိန်",
traffic_access: "ယာဉ်အသွားအလာ၊",
traffic_access_desc: " အများပြည်သူသယ်ယူပို့ဆောင်ရေးဆိုင်ရာအချက်အလက်တွေသာမက ၀ န်ထမ်းတွေအတွက်ကားရပ်နားရန်နေရာများရှိမရှိ၊ ကားဖြင့်ခရီးသွားခြင်းစတာတွေပါ။ ",
required: "လိုအပ်တယ်",
optional: "Any ",
other: "အခြား၊",
photo: "ဓာတ်ပုံ၊",
upload_video: "ဗွီဒီယိုတင်ပါ",
job_tag: "Job Tag၊",
until_select_three: "ရွေးစရာ ၃ ခုအထိ၊",
senior_support: "အကြီးတန်းပံ့ပိုးမှု၊",
salary_increase_promotion: "လစာတိုးမြှင့် / မြှင့်တင်ရေးရရှိနိုင်",
no_overtime: "အချိန်ပိုမရှိ",
target_hiring_time: "စုဆောင်းမှုရည်မှန်းချက်အချိန်",
additional_questions: "နောက်ထပ်မေးခွန်းများ",
job_offer_title: "ယောဘအမည်၊",
public: "လွှတ်ပါ",
private: "private၊",
public_status: "လူထုအခြေအနေ၊",
occupation: "အလုပ်အကိုင်",
walfare: "ကုသမှု / အကျိုးကျေးဇူးများ၊",
create: "&quotဖန်တီး&quot",
hour: "အချိန်",
back_mypage: "ငါ့စာမျက်နှာသို့ပြန်သွားပါ",
job_offers: "အလုပ်စာရင်း၊",
look_matches: "ပွဲစာရင်းကိုကြည့်ပါ",
now_public: "ယခုဖွင့်",
now_private: "အတည်မပြုရသေးသော၊",
check: "အတည်ပြုပါ၊",
edit2: "တည်းဖြတ်ရန်၊",
news_detail: "သတင်းအသေးစိတ်များ၊",
prefectures: "စီရင်စုများ၊",

hokkaido: "ဟော့ကိုင်းဒို",
aomori: "Aomori၊",
iwate: "Iwate၊",
miyagi: "မိယာဂီ၊",
akita: "Akita",
yamagata: "ယာမာဂတာ၊",
fukushima: "ဖူကူရှီးမား",
ibaraki: "အီဘရာကီ",
tochigi: "Tochigi၊",
gunma: "Gunma၊",
saitama: "Saitama၊",
chiba: "Chiba၊",
tokyo: "တိုကျို",
kanagawa: "ကန်နာဂါ၊",
niigata: "နီဂို၊",
toyama: "&quotToyama&quot၊",
ishikawa: "အီရှီကာဝါ",
fukui: "ဖူကူ၊",
yamanashi: "ရာမနရှီ၊",
nagano: "Nagano၊",
gifu: "Gifu၊",
shizuoka: "Shizuoka",
aichi: "Aichi၊",
mie: "Triple၊",
shiga: "Shiga",
kyoto: "ကျိုတို၊",
osaka: "အိုဆာကာ၊",
hyogo: "Hyogo၊",
nara: "နာရာ",
wakayama: "ဝကယာမ၊",
tottori: "Tottori၊",
shimane: "Shimane၊",
okayama: "အိုကေယာမာ",
hiroshima: "ဟီရိုရှီးမား၊",
yamaguti: "ယာမာဂူချီ၊",
tokushima: "တိုကူရှီမား၊",
kagawa: "ကာဂါဝါ၊",
echime: "Ehime",
kochi: "Kochi",
fukuoka: "ဖူကူကူ",
saga: "စစ်ကိုင်း၊",
nagasaki: "&quotနာဂါဆာကီ&quot",
kumamoto: "Kumamoto၊",
oita: "အိုတီ",
miyazaki: "မီယာဇာကီ၊",
kagoshima: "ကာဂူရှီမာ၊",
okinawa: "အိုကီနာဝါ၊",
sinhalese: "ဆင်ဟာလ",
exam_region: "စီရင်စုများ၊",
exam_place_list: "နေရာများစာရင်း",
exam_place_name: "စာမေးပွဲနေရာအမည်",
care_evaluation_test: "ရေရှည်စောင့်ရှောက်မှုစွမ်းရည်လေ့ကျင့်ရေးအကဲဖြတ်စစ်ဆေးမှု၊",
clean_building_test: "ဆောက်လုပ်ရေးလုပ်ငန်းမှာသန့်ရှင်းရေးလုပ်တဲ့စက်ရုံပြproblemsနာတွေ၊",
answer: "အဖြေ၊",
skill_test_measurement: "ကျွမ်းကျင်မှုတိုင်းတာခြင်းစမ်းသပ်မှု၊",
exam_problem: "စာမေးပွဲမေးခွန်း၊",
fields: "လယ်ကွင်းများနှင့်ဟင်းသီးဟင်းရွက်များ၊",
gardening: "ဥယျာဉ်ခြံဥယျာဉ်၊",
mushroom: "မှို",
fruit: "သစ်သီးပင်၊",
dairy: "နို့ထွက်ပစ္စည်း",
poultry: "ကြက်၊",
pig: "ဝက်မွေးမြူခြင်း၊",
beginner: "Beginner၊",
professional: "အတန်းအဆင့်၊",
advanced: "အဆင့်မြင့်၊",
technical_training_test: "နည်းပညာဆိုင်ရာသင်တန်းသားလေ့ကျင့်မှုအကဲဖြတ်စစ်ဆေးမှု၊",
exam_part: "စာမေးပွဲမေးခွန်း၏အပိုင်း၊",
tokoha_fruit: "တိုကျိုသစ်သီးပင်",
deciduous_fruit: "ရွက်ကြွေအသီးပင်။",
ver: "Edition၊",
errata: "Errata၊",
form_work: "Formwork ဆောက်လုပ်ရေး၊",
construction: "အင်္ဂတေ၊",
tunnel_line: "ဥမင်လိုဏ်ခေါင်းလိုင်း၊",
earth_work: "Earthwork၊",
loofing: "ခေါင်မိုး",
elecommunication: "ဆက်သွယ်ရေး၊",
reinforcing_contstruction: "ဘားဆောက်လုပ်ခြင်းအားဖြည့်ခြင်း၊",
reinforcing_joint: " ခိုင်ခံ့အားဖြည့်ဘားပူးတွဲ",
wall_painting: "ပန်းချီကား (နံရံအဖုံး)၊",
board_finish: "ဘုတ်အဖွဲ့ပြီး၊ အတွင်းပိုင်း၊",
steeplejack: "Tobi၊",
spray_insulation: "ပက်ဖြန်း Urethane insulation၊",
marine_civil: "ရေကြောင်းမြို့ပြအင်ဂျင်နီယာ၊",
concrete_pumping: "ကွန်ကရစ်ပန့်",
construction_machinery: "ဆောက်လုပ်ရေးသုံးစက်ကိရိယာဆောက်လုပ်ရေး၊",
learning_text: "စာသားသင်ယူခြင်း၊",

basic_aircraft: "အခြေခံလေယာဉ်နည်းပညာနိဂုံး၊ လျှပ်စစ်တိုင်းတာခြင်း၊",
worksafety_quality: "အလုပ်လုံခြုံမှု၊ အရည်အသွေး၊",
aircraft_overview: "လေယာဉ်၏ခြုံငုံသုံးသပ်ချက်၊",
fish_general: "ယေဘုယျအားဖြင့်ငါးလုပ်ငန်း၊",
fish_safety: "ငါးလုပ်ငန်းလုံခြုံမှု၊",
network_relations: "ငါးလုပ်ငန်းအထူးသင်တန်းများ၊",
fish_relations: "ငါးလုပ်ငန်းအထူးငါးဖမ်းလုပ်ငန်း",
aquaculture_general: "ယေဘုယျအားဖြင့်ငါးမွေးမြူရေး၊",
feeding_aquaculture: "ငါးမွေးမြူရေးအထူးအစားအစာနှင့်ငါးမွေးမြူရေးနှင့်ဆက်စပ်သော",
unfed_aquaculture: "ငါးမွေးမြူရေးလုပ်ငန်းအထူးငါးမွေးမြူရေးနှင့်မသက်ဆိုင်သော၊",
attachment: "ချိတ်တွဲ များ၊",
glossary: "ဝေါဟာရ၊",
feneral_customer: "အထွေထွေဖောက်သည်ဝန်ဆောင်မှု၊",
food_dring_cooking: "အစားအစာချက်ပြုတ်ခြင်း၊",
hygiene_management: "တစ်ကိုယ်ရေသန့်ရှင်းရေးစီမံခန့်ခွဲမှု၊",
visa_application: "တိကျသောကျွမ်းကျင်မှုဗီဇာအတွက်လျှောက်လွှာ၊",
certificate_residence_tax: "၁။ နေထိုင်ခွင့်ခအခွန် (ပြီးခဲ့သည့်နှစ်အတွက်)၊",
salary_income_withholding : "“ ၂။ လစာ ၀ င်ငွေခွန်မိတ္တူ”၊",
national_health_insured: "၃။ အမျိုးသားကျန်းမာရေးအာမခံအာမခံကုမ္ပဏီ၏ကဒ်မိတ္တူတစ်စုံ (အကယ်၍ စာရင်းသွင်းလျှင်)၊",
national_health_payment: "၄။ အမျိုးသားကျန်းမာရေးအာမခံပရီမီယံငွေပေးချေမှုလက်မှတ်၊",
national_health_receipt: "၅။ အမျိုးသားကျန်းမာရေးအာမခံပရီမီယံလက်ခံဖြတ်ပိုင်းမိတ္တူ၊",

technical_intern_training2: "၆။ နည်းပညာဆိုင်ရာအလုပ်သင်သင်တန်းအမှတ် (၂) ကိုအောင်မြင်စွာပြီးဆုံးကြောင်းထောက်ခံချက်စာရွက်စာတမ်းများ",
need_the_following : "အောက်ပါတို့မှတစ်ခုကိုသင်လိုအပ်သည် - ",
pass_certificate_test_specialized : " ကျွမ်းကျင်မှုအကဲဖြတ်စစ်ဆေးမှု (အထူးတန်း) ၏လက်တွေ့ကျွမ်းကျင်မှုစာမေးပွဲအောင်လက်မှတ်မိတ္တူတစ်စောင်၊",
technical_intern_training3: "・ ကျွမ်းကျင်မှုစာမေးပွဲ (၃ တန်း) ၏လက်တွေ့ကျသောစာမေးပွဲအောင်စာရင်းမိတ္တူတစ်စုံ၊",
evaluation_record_technical_intern: "the အထက်ပါစာမေးပွဲကိုသင်မအောင်မြင်လျှင်၊ အလုပ်သင်သင်တန်းသားအတွက်စစ်ဆေးမှုမှတ်တမ်းကိုသင်ဖြည့်ရမည်။ ",
cartificate_pass_basic_test: "၇.၆ အစားအခြားနည်းလမ်းတစ်ခုအနေဖြင့်၊ သင်သည်ဂျပန်နိုင်ငံဖောင်ဒေးရှင်း၏အခြေခံစာမေးပွဲမိတ္တူတစ်ခုသို့မဟုတ်ဂျပန်စာကျွမ်းကျင်မှုစာမေးပွဲ (N4) နှင့်အထက်စာမေးပွဲမိတ္တူတစ်ခုကိုတင်သွင်းနိုင်သည်။ ",
change_permission_application: "၈။ ပြောင်းလဲမှုခွင့်ပြုချက်လျှောက်လွှာ၏ဓာတ်ပုံ (ဒေါင်လိုက် ၄ စင်တီမီတာအလျားလိုက် ၃ စင်တီမီတာ)",
resume_data_time_entry: "၉။ ၀ င်ရောက်သည့်အချိန်တွင်အချက်အလက်များပြန်လည်စတင်ပါ။ ",
select_file: "ဖိုင်ရွေးရန်",

description_movie: "ရှင်းလင်းချက်ဗွီဒီယို",
how_to_use_movie: "ဗွီဒီယိုကိုဘယ်လိုအသုံးပြုမလဲ",
movie_news: "၁။ တိကျသောကျွမ်းကျင်မှုဗီဇာအကြောင်းသတင်း",
movie_exam: "၂။ စမ်းသပ်သည့်နေ့အထိကျန်ရှိသောရက်အရေအတွက်",
movie_predict_pass: "3. ခန့်မှန်း pass နှုန်း",
movie_ave_study_test: "၄။ သင်လေ့လာခဲ့သောကိုယ်ပိုင်စာမေးပွဲ၏ပျှမ်းမျှရမှတ်",
movie_similar_exam: "၅။ အလားတူစာမေးပွဲမေးခွန်းများ",
movie_learning_text: "၆ ။",
movie_solved_exam: "၇။ ကျွန်ုပ်ယခင်ကဖြေရှင်းခဲ့သောပြProbleနာများ",
movie_pased_exam: "၈။ အမှန်တကယ်ပေါ်ပေါက်လာခဲ့သောအတိတ်ပြproblemsနာများကိုကြည့်ခြင်းအကြောင်း",
movie_resume_regist: "၉။ ၀ င်ရောက်သည့်အချိန်တွင်မှတ်ပုံတင်ပါ",
movie_pass_document_regist: "၁၀။ စာမေးပွဲအောင်လက်မှတ်မှတ်ပုံတင်ခြင်း",
movie_agency_service: "11. စာမေးပွဲလျှောက်လွှာအေဂျင်စီဝန်ဆောင်မှု",
movie_consule_service: "၁၂",
description_movie_trans: "အကယ်၍ သင်သည်ဂျပန်မဟုတ်သည့်အခြားဘာသာစကားဖြင့်ကြည့်လိုပါကဂီယာအမှတ်အသားကိုနှိပ်ပါ၊ စာတန်းထိုးများနှင့်အလိုအလျောက်ဘာသာပြန်ခြင်းကိုနှိပ်ပါ၊ သင့်မိခင်ဘာသာစကားကိုရွေးချယ်ပါ၊ ပြီးနောက်ကြည့်ပါ။",
"cultivated_agriculture_general": "កសិកម្មដាំដុះជាទូទៅ",
"livestock_agriculture": "កសិកម្មចិញ្ចឹមសត្វ",
"介護": "ថែទាំ",
"ビルクリーニング": "ការសម្អាតអគារ",
"建設": "សំណង់",
"自動車整備": "ការថែទាំរថយន្ត",
"航空業": "ឧស្សាហកម្មអាកាសចរណ៍",
"農業": "កសិកម្ម",
"漁業": "ការនេសាទ",
"飲食料品製造業": "ឧស្សាហកម្មផលិតអាហារ និងភេសជ្ជៈ",
"外食業": "អាជីវកម្មភោជនីយដ្ឋាន",
"型枠施工": "ការសាងសង់ទម្រង់",
"左官": "ជាងម្នាងសិលា",
"コンクリート圧送": "ការបូមបេតុង",
"トンネル推進工": "ការងារជំរុញផ្លូវរូងក្រោមដី",
"建設機械施工": "ការសាងសង់គ្រឿងចក្រសំណង់",
"大工": "ជាងឈើ",
"屋根ふき": "ដំបូល",
"電気通信": "ទូរគមនាគមន៍",
"鉄筋施工": "ការពង្រឹងការសាងសង់របារ",
"鉄筋継手": "ការពង្រឹងសន្លាក់របារ",
"壁装　（壁張り）": "គម្របជញ្ជាំង (ជញ្ជាំង)",
"ボード仕上げ、内装仕上げ": "ការបញ្ចប់ក្តារ, ផ្ទៃខាងក្នុង",
"とび": "លោត",
"吹き付けウレタン断熱": "បាញ់អ៊ីសូឡង់ urethane",
"海洋土木工": "វិស្វកម្មស៊ីវិលសមុទ្រ",
"航空機の基本技術 締結、電気計測": "ការសន្និដ្ឋានបច្ចេកវិទ្យាមូលដ្ឋានយន្តហោះ ការវាស់វែងអគ្គិសនី",
"作業安全、品質": "សុវត្ថិភាពការងារ គុណភាព",
"航空機概要": "ទិដ្ឋភាពទូទៅនៃយន្តហោះ",
"耕種農業全般": "កសិកម្មដាំដុះជាទូទៅ",
"畜産農業": "កសិកម្មចិញ្ចឹមសត្វ",
"漁業一般": "ការនេសាទជាទូទៅ",
"漁業安全": "សុវត្ថិភាពជលផល",
"漁業専門 綱関係": "ទំនាក់ទំនងខ្សែពួរ ជំនាញជលផល",
"漁業専門 釣り関係": "ជំនាញក្នុងការនេសាទទាក់ទងនឹងការនេសាទ",
"養殖業一般": "ជាទូទៅវារីវប្បកម្ម",
"養殖業専門 給餌養殖関係": "ឯកទេសវារីវប្បកម្ម ការចិញ្ចឹមវារីវប្បកម្ម",
"養殖業専門 無給餌養殖関係": "ជំនាញវារីវប្បកម្ម Unfed វារីវប្បកម្ម",
"接客全般": "សេវាកម្មអតិថិជនទូទៅ",
"飲食物調理": "ចម្អិនអាហារនិងភេសជ្ជៈ",
"衛生管理": "ការគ្រប់គ្រងអនាម័យ",
"日本語版": "កំណែភាសាជប៉ុន",
"英語版": "ការបោះពុម្ពភាសាអង់គ្លេស",
"クメール語版": "ភាសាខ្មែរ",
"インドネシア語版": "កំណែឥណ្ឌូនេស៊ី",
"インドネシア語・正誤表": "កំហុសឥណ្ឌូនេស៊ី",
"ネパール語版": "កំណែភាសានេប៉ាល់",
"モンゴル語版": "កំណែម៉ុងហ្គោលី",
"ビルマ語版": "កំណែភូមា",
"ベトナム語版": "កំណែវៀតណាម",
"タイ語版": "កំណែភាសាថៃ",
"テキスト１": "អត្ថបទ ១",
"テキスト２": "អត្ថបទ ២",
"テキスト３": "អត្ថបទ ៣",
"テキスト４": "អត្ថបទ ៤",
"テキスト５": "អត្ថបទ ៥",
"ミャンマー(ビルマ)語版": "កំណែ​ភាសា​ភូមា (ភូមា)",
"カンボジア(クメール)語版": "ភាសាខ្មែរ (ខ្មែរ)",
"ミャンマー語版": "កំណែភូមា",
"中国語版": "កំណែភាសាចិន",
"付属資料": "ឯកសារ​ភ្ជាប់",
"用語集": "សទ្ទានុក្រម",
"invitation_code": "លេខ​កូដ​ការ​អញ្ជើញ",
"exam_calender": "កាលវិភាគប្រឡង",
"move_exam_detail": "តើ​អ្នក​ចង់​ចូល​ទៅ​ទំព័រ​លម្អិត​តារាង​ពេល​ប្រឡង​ដែរ​ឬ​ទេ?",
"move": "ផ្លាស់ទី",
"plece_select_language": "សូមជ្រើសរើសភាសា",
"select": "ជ្រើសរើស",
"midle_category": "មុខរបរ",
"select_industry_description": "នៅពេលចាប់ផ្តើម AELU អាចជ្រើសរើសបានត្រឹមតែ 3 ឧស្សាហកម្មប៉ុណ្ណោះ ដូច្នេះសូមជ្រើសរើសតែឧស្សាហកម្មដែលអ្នកចង់ធ្វើការ។ បើមើលទៅមិនអីទេ សូមចុច Next",
"done_member_regist_description_2": "ចាប់ពីពេលនេះតទៅ យើងនឹងគាំទ្រ AELU ដើម្បីទទួលបានទិដ្ឋាការជំនាញជាក់លាក់មួយ ដោយរៀបចំការប្រឡងវិញ្ញាបនប័ត្រជាច្រើន។",
"done_member_regist_2": "ការចុះឈ្មោះសមាជិកបានបញ្ចប់។",
"is_exist_user": "អ្នកប្រើប្រាស់ដែលមានអាសយដ្ឋានអ៊ីមែលដូចគ្នាមានរួចហើយ។",
"invitation_code_description": "(សូមបញ្ចូលលេខកូដអញ្ជើញពីស្ថាប័នបញ្ជូន ឬសាលាភាសាជប៉ុន បើមិនដូច្នេះទេ អេក្រង់ទូទាត់ចំណាយនឹងបង្ហាញឡើង ដូច្នេះកុំភ្លេចបញ្ចូលវាផង។)",
"pleace_select_region": "សូមជ្រើសរើសខេត្តម្ចាស់ផ្ទះ",
"pleace_add_messenger": "ទំនាក់ទំនងទាំងអស់នឹងត្រូវបានផ្ញើតាមរយៈសារ Facebook ដូច្នេះត្រូវប្រាកដថាបន្ថែមពួកគេ។",
"add_messenger_bot": "ទទួលការជូនដំណឹង",
"visa_application_description": "ទីតាំងផ្ទុកឯកសារដែលត្រូវការនៅពេលដាក់ពាក្យសុំទិដ្ឋាការជំនាញជាក់លាក់",
"check_agree": "សូមយល់ព្រម",
"sample_title": "នេះជាចំណងជើងអត់ចេះសោះ។ សូមកំណត់",
"sample_description": "នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។",
"create_profile_error": "មាន​កំហុស​ក្នុង​ការ​បញ្ចូល។ សូមពិនិត្យមើលធាតុ",
"setting_confirm": "សូមបញ្ជាក់ខ្លឹមសារបញ្ចូល ហើយចុះឈ្មោះ",
"exam_learning": "ការរៀនប្រឡង",
"recommend_problem_solve": "ដោះស្រាយសំណួរប្រឡងស្រដៀងគ្នា",
"of": "នៃ",
"see_solved_problem": "ដោះស្រាយបញ្ហាដែលអ្នកបានដោះស្រាយនាពេលកន្លងមក\\n",
"past_exam_collection": "\\n សំណួរប្រឡងដែលបានលេចឡើងនាពេលកន្លងមក",
"any_application_registration": "ការចុះឈ្មោះកម្មវិធីផ្សេងៗ",
"mypage_visa_application": "ទិដ្ឋាការជំនាញជាក់លាក់\\nកម្មវិធី",
"applyt_exam_and_agent": "កម្មវិធីប្រឡង\\nកម្មវិធីសេវាប្រូកស៊ី",
"myapge_regist_accept_certificate": "តេស្តជំនាញ\\nចុះឈ្មោះប្រឡង",
"mypage_consultaion_service": "ការប្រឹក្សាយោបល់\\nសេវាកម្ម",
"consult": "ពិគ្រោះ",
"of_exam_day": "កាលបរិច្ឆេទសាកល្បង",
"your_ave_score": "ពិន្ទុមធ្យមសម្រាប់ការធ្វើតេស្ត \\n របស់អ្នក។",
"your_estimated_pass_rate": "\\n អត្រាឆ្លងតាមការប៉ាន់ស្មានរបស់អ្នក។",
"your_ave_score_fotter": "ពិន្ទុមធ្យមសម្រាប់ការធ្វើតេស្តរបស់អ្នក។",
"your_estimated_pass_rate_fotter": "អត្រាឆ្លងកាត់ប៉ាន់ស្មាន",
"mypage_study_text": "ទាញយកសៀវភៅសិក្សា\\n",
"exam_schedule": "កាលវិភាគប្រឡង",
"resident_caption_title": "● អំពីការបង្ហោះប័ណ្ណស្នាក់នៅ ឬអត្តសញ្ញាណប័ណ្ណ",
"resident_caption": "សូមបង្ហោះប័ណ្ណស្នាក់នៅ ឬអត្តសញ្ញាណប័ណ្ណដែលអាចបញ្ជាក់ព័ត៌មានក្នុងស៊ុមក្រហម។ \\nសូមបង្ហោះប័ណ្ណស្នាក់នៅដែលមានសុពលភាព ឬអត្តសញ្ញាណប័ណ្ណដែលមិនទាន់ផុតកំណត់។ \\nបង្ហោះរូបភាពពណ៌ជាទម្រង់ PDF ឬ JPG ។",
"password_caption_title": "● អំពីការបង្ហោះពាក្យសម្ងាត់",
"password_caption": "សូមបង្ហោះរូបភាពលិខិតឆ្លងដែនដែលបញ្ជាក់ឈ្មោះ/រូបថត/លេខពិសេស/ថ្ងៃខែឆ្នាំកំណើត/សញ្ជាតិ/ថ្ងៃផុតកំណត់ដូចបង្ហាញក្នុងស៊ុមក្រហម។ \\nសូមបង្ហោះលិខិតឆ្លងដែនដែលមានសុពលភាពដែលមិនទាន់ផុតកំណត់។ \\nបង្ហោះរូបភាពពណ៌ជាទម្រង់ PDF ឬ JPG ។",
"title_help": "ជួយ",
"step3_title_help": "សូមបញ្ចូលព័ត៌មានរបស់អ្នកឱ្យបានត្រឹមត្រូវ។",
"lineid_input_help": "បើក LINE → Home → Settings → Profile → Scroll ដើម្បីមើល ID។ សូមបញ្ចូលលេខសម្គាល់នោះ។ ប្រសិនបើអ្នកមិនទាន់បានបង្កើតវាទេ សូមបង្កើតវា ហើយបញ្ចូលវា។",
"country_input_help": "សូមជ្រើសរើសប្រទេសដែលមានសញ្ជាតិរបស់អ្នក។",
"area_input_help": "ជ្រើសរើសប្រទេសនៃតំបន់របស់អ្នកដែលអ្នករស់នៅបច្ចុប្បន្ន។",
"phone_input_help": "សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក។",
"issuing_input_help": "សូមជ្រើសរើសតំបន់ដែលអត្តសញ្ញាណប័ណ្ណរបស់អ្នកត្រូវបានចេញ។",
"idtype_input_help": "សូមជ្រើសរើសប្រភេទលេខសម្គាល់។ សូមថតរូបដ៏ស្រស់ស្អាតរបស់អ្នកដែលបានជ្រើសរើស ហើយបង្ហោះវា។ សូម​បាញ់​ត្រង់​ដើម្បី​កុំ​ឲ្យ​មាន​ចំណុច​អង្កត់ទ្រូង ឬ​កាត់។",
"invitation_input_help": "ប្រសិនបើអ្នកមានលេខកូដអញ្ជើញ សូមបញ្ចូលវា។",
"exam_menu_help": "វានឹងមានសំណួរដែលស្រដៀងនឹងសំណួរដែលត្រូវបានសួរកាលពីអតីតកាល។ ដោះស្រាយសំណួរដដែលៗ ដើម្បីត្រៀមប្រឡង។",
"past_menu_help": "អ្នកនឹងមានបញ្ហាដែលអ្នកបានដោះស្រាយនាពេលកន្លងមក។ ចូរយើងពិនិត្យមើលកំហុស។",
"pastexam_menu_help": "នេះ​ជា​អត្ថបទ​នៃ​សំណួរ​ប្រឡង​ដែល​ពិត​ជា​កន្លង​មក។",
"text_menu_help": "អ្នក​អាច​មើល​សៀវភៅ​សិក្សា​ដើម្បី​សិក្សា​ចំណុច​សំខាន់ៗ​និង​រក​ឃើញ​នូវ​អ្វី​ដែល​អ្នក​មិន​យល់។",
"visa_menu_help": "យើងនឹងជួយអ្នកឱ្យទទួលបានទិដ្ឋាការជំនាញជាក់លាក់មួយ។ ប្រសិនបើអ្នកចង់ទទួលបានទិដ្ឋាការសម្រាប់ជំនាញជាក់លាក់មួយ សូមដាក់ពាក្យនៅទីនេះ។",
"agency_menu_help": "យើង​នឹង​ដាក់​ពាក្យ​សម្រាប់​ការ​ធ្វើ​តេស្ត​សមត្ថភាព​ជាក់លាក់​ក្នុង​នាម​អ្នក​។ ប្រសិនបើអ្នកចង់ប្រលងជំនាញជាក់លាក់ សូមដាក់ពាក្យនៅទីនេះ។",
"cer_menu_help": "ប្រសិនបើអ្នកបានធ្វើតេស្តសមត្ថភាពជាក់លាក់ និងមានវិញ្ញាបនបត្រឆ្លងកាត់ សូមចុះឈ្មោះនៅទីនេះ។",
"service_menu_help": "ប្រសិនបើអ្នកមានចម្ងល់ ឬកង្វល់ សូមទាក់ទងមកយើងខ្ញុំតាមរយៈការជជែកនៅទីនេះ។",
"occu_title_help": "សូមជ្រើសរើសមុខរបរដែលចង់បានរហូតដល់ 3។",
"back": "ပြန်လာ",
"before": "အရင်ပြဿနာ",
srilank: "သီရိလင်္ကာ",
reselect: "ဖိုင်ကိုပြောင်းလိုပါက &quot;သင်၏ပတ်စ်ပို့ကို တင်ပါ&quot; ကို ထပ်မံနှိပ်ပြီး ထပ်မံရွေးချယ်ပါ။",
iphone_file: "iPhone အတွက် HEIC ဖိုင်မှ JPG ဖိုင်သို့ ပြောင်းပြီးနောက် အသုံးပြုပါ။",
file_transmit: "ဖိုင်များကိုပြောင်းပါ။",
combodia: 'combodia',

}
